window.theme = window.theme || {};
window.slate = window.slate || {};

const pstTimezone = 'America/Los_Angeles';
const dateTimeInPstTimezone = luxon.DateTime.now().setZone(pstTimezone);

let disabledDeliveryDates = [];
var currentPath = window.location.pathname;
const fetchHolidays = new Event('resultFetched');
let locationId;

if (currentPath.includes("/cart") || currentPath.includes("/products")) {
  const csFormDataC = new FormData();
  csFormDataC.append("shop", "db-tricity.myshopify.com");
  csFormDataC.append("product_ids", []);
  
  fetch("https://sbz.cirkleinc.com/cs-sbz-front-data", {
    method: "POST",
    body: csFormDataC
  })
  .then((response) => response.json())
  .then((result) => {
    disabledDeliveryDates = result.shippingDeliveryDateSettingData.disable_shipping_date;
    locationId = result.locations[0].id;
    document.dispatchEvent(fetchHolidays);
  })
  .catch((error) => {
    console.error("An error occurred:", error);
  });
}


/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _loadSubSections: function() {
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    if(options.$container.selector != '#NavDrawer'){ //Do not apply tabindex=-1 on Nav Drawer
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
    }

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ MODULES ================*/
window.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element'),
      $moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    this.$open = $(this.config.open);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    this.$open.attr('aria-expanded', 'false');
    this.$open.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      return;
    }

    this.$open.addClass(this.config.openClass);

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function() {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    this.$open.removeClass(this.config.openClass);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    // Clicking out of drawer closes it
    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.QtySelector = (function() {
  var QtySelector = function($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function() {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function(line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function(cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function(
    line,
    quantity,
    id,
    product
  ) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (
      variant.inventory_management !== null &&
      variant.inventory_policy === 'deny'
    ) {
      if (variant.inventory_quantity < quantity) {

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function(evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  QtySelector.prototype.bindEvents = function() {
    this.$wrapper
      .find('.js-qty__adjust')
      .on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function() {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        'change',
        '.js-qty__input',
        $.proxy(function(evt) {
          var $input = $(evt.currentTarget);
          var line = $input.attr('data-line');
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this)
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function(line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function() {
        this.validateAvailability(line, qty);
      }, this),
      200
    );
  };

  QtySelector.prototype.updateItemQuantity = function(line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function(cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function(cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      if (cartItem.image === null) {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_240x240$1')
          .replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        index: index,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(
          cartItem.line_price,
          theme.moneyFormat
        ),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
      theme.updateCurrencies();
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function(i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(
        theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        )
      );
    } else {
      this.cache.$discountTotal.empty();
    }
    
    theme.miniCart.updateElements();
    theme.updateCurrencies();
    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function() {
  var styleCart = $('.js-mini-cart').attr("data-cartmini");
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };

    this.$form = $form;
    this.eventListeners();
    
    this.showNotice = false;
    if (this.$form.length) {
      this.showNotice  = this.$form.hasClass('js-form--notice')? true : false;
    }
  };

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function(evt) {
    evt.preventDefault();

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this)
    };

    $.ajax(params);
  };
  
  cart.prototype.success = function(item) {
    theme.miniCart.updateElements();
    theme.miniCart.generateCart();
    if(styleCart != 'true' ){
      if (this.showNotice) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
      }else{
        theme.crosssell.showPopup(item);
      }
    }
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    
    if (data.message) {
      theme.alert.new('',data.description,3000,'warning');
    }
  };

  return cart;
})();

/*================ TEMPLATES ================*/
theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$('.reset-password-success').length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
theme.HeaderSection = (function() {
  function Header() {
    theme.NavDrawer = new window.Drawers('NavDrawer', 'left');
  }

  return Header;
})();

theme.Product = (function() {
  var defaults = {
    smallBreakpoint: 750,
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.js-variant-sku',
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productThumbContainers: '.product-single__thumbnail-item-' + sectionId,
      productThumbsWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbs: '.product-single__thumbnail-' + sectionId,
      saleTag: '#ProductSaleTag-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      availability: '.product-single__availability',
      hurrify : '.js-hurrify'
    };

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      ajaxCart: $container.data('ajax'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      this._productThumbSwitch();
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(
          $('#AddToCartForm-' + this.settings.sectionId)
        );
      }
    },

    _stringOverrides: function() {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse(
        $('#VariantJson-' + this.settings.sectionId).html()
      );

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCartBtn.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateStickyCart.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
    },

    _updateStock: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock),
          $hurrify = $(this.selectors.hurrify);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(
            theme.strings.stockAvailable.replace(
              '1',
              variant.inventory_quantity
            )
          )
          .removeClass('hide');
        $hurrify.removeClass('hide').find('.progress-bar').css('width',variant.inventory_quantity*10+'%');
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(
            theme.strings.willNotShipUntil.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
      $hurrify.addClass('hide');
    },

    _updateIncomingInfo: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(
            theme.strings.willBeInStockAfter.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function(evt) {
      var variant = evt.variant;

      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText)
      };

      if (variant) {
        // Select a valid variant if available
        theme.noticeSoldout.init(variant);
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
          //update availability - available
          $(this.selectors.availability).find('span').text(theme.strings.available);
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
          //update availability - soldout
          $(this.selectors.availability).find('span').text(theme.strings.soldOut);
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        //update availability - unavailable
        $(this.selectors.availability).find('span').text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
        }
        
        theme.updateCurrencies();
      } else {
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        var imageId = variant.featured_image.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },
    _updateStickyCart: function (evt){
      var variant = evt.variant,
          $stickyPrice = $('#js-sticky-price'),
          $stickyTitle = $('#js-sticky-title'),
          $stickyImage = $('#js-sticky-img'),
          $stickyButton = $('#js-sticky-btn');
      if (variant) {
        //update title
        $stickyTitle.html(' - ' + variant.title);
        //update price
        $stickyPrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
        //update selectbox
        for (var i = 1; i <= 3; i++) {
          var option = 'option' + i,
              $selecBox = '#js-sticky-option-' + i;
          if (variant[option] !== null){
            var valueOption = variant[option];
            $($selecBox).val(valueOption);
          }
        }
        //update button cart
        if (variant.available) {
          $stickyButton.prop('disabled', false).removeClass('btn--sold-out');
          $stickyButton.html(theme.strings.addToCart);
        } else {
          $stickyButton.prop('disabled', true).addClass('btn--sold-out');
          $stickyButton.html(theme.strings.soldOut);
        }
        //update image
        if (variant.featured_image) {
          $stickyImage.attr('src',theme.Images.getSizedImageUrl(variant.featured_image.src,'200x'));
        }
      } else {
        //update title
        $stickyTitle.html(' - ' + theme.strings.unavailable);
        //update button cart
        $stickyButton.prop('disabled', true).removeClass('btn--sold-out');
        $stickyButton.html(theme.strings.unavailable);
      }
    },

    switchProductImage: function(imageId) {
      var $imageToShow = $(
        this.selectors.productImageContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $imagesToHide = $(
        this.selectors.productImageContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $imagesToHide.addClass('hide');
      $imageToShow.removeClass('hide');
      //Scroll to active
      topMenuHeight = $('.site-header').outerHeight();
      if(this.settings.sectionId === 'product-template-8'){
        $([document.documentElement, document.body]).animate({
          scrollTop: $imageToShow.offset().top-topMenuHeight
        }, 500);
      }
    },

    setActiveThumbnail: function(imageId) {
      var $thumbnailToShow = $(
        this.selectors.productThumbContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $thumbnailsToHide = $(
        this.selectors.productThumbContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $thumbnailsToHide.removeClass('is-active');
      $thumbnailToShow.addClass('is-active');
      $thumbnailToShow.trigger('click');
      var $thumbnails = $(this.selectors.productThumbsWrapper, this.$container);

      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnails.hasClass('slick-initialized')) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
        var newActiveSlideIndex = parseInt(
          $thumbnailToShow.attr('data-slick-index')
        );
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
         
        }
      }
    },

    _productZoomImage: function() {
      // The zoom image is only used on the product template, so return early
      // even if a featured product section is present.
      if (
        !$('.product-single ' + this.selectors.productImageContainers).length
      ) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          // Empty src before loadig new image to avoid awkward image swap
          $(self.selectors.productZoomImage)
            .attr('src', '')
            .attr('src', $(this).attr('href'));
        }
      );

      this.ProductModal = new window.Modals(
        this.selectors.modal,
        'product-modal'
      );

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on('click' + this.settings.namespace, function(
        evt
      ) {
        if (evt.target.nodeName !== 'IMG') {
          self.ProductModal.close();
        }
      });
    },

    _productThumbSwitch: function() {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbs).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          var imageId = $(this)
            .parent()
            .data('image-id');
          self.setActiveThumbnail(imageId);
          self.switchProductImage(imageId);
        }
      );
      //trigger hover thumb
      // $(this.selectors.productThumbs).on('click',function(){
      //   $(this).trigger('click');
      // });
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function() {
      var $productThumbsWrapper = $(this.selectors.productThumbsWrapper);
      var $productThumbs = $(this.selectors.productThumbs);
      if (!$productThumbs.length) {
        return;
      }

      if ($productThumbs.length > 1) {
        $productThumbsWrapper.on(
          'init' + this.settings.namespace,
          this._productSwipeInit.bind(this)
        );
        
        if (this.settings.sectionId === 'product-template-3' || this.settings.sectionId === 'product-template-4'){
          $productThumbsWrapper.slick({
            accessibility: false,
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            vertical: true,
            verticalSwiping: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  vertical: false,
                  verticalSwiping: false,
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  dots: false,
                }
              }
            ]
          }).css('opacity','1');
        }else if(this.settings.sectionId === 'product-template-5'){
          $productThumbsWrapper.slick({
            accessibility: false,
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  dots: false,
                }
              }
            ]
          }).css('opacity','1');
        }
        else if(this.settings.sectionId === 'product-template-7'){
          $productThumbsWrapper.slick({
            accessibility: false,
            arrows: true,
            dots: true,
            infinite: true,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: false,
                  arrows: true,
                }
              }
            ]
          }).css('opacity','1');
        }
        else if (this.settings.sectionId === 'product-template-8' ){
          var lastId,
              topMenu = $(".product-single__thumbnails"),
              topMenuHeight = $('.site-header').outerHeight()+20,
              // All list items
              menuItems = topMenu.find(".product-single__thumbnail");
             
             
          if ($(window).width() > 767) {
              menuItems.click(function (e){
              var findid =$(this).attr('href');
              offsetTop = $(findid).offset().top-topMenuHeight + 1;
              $('html, body').stop().animate({
                  scrollTop: offsetTop
              },200);
              return false;
            });
              // Anchors corresponding to menu items
              scrollItems = menuItems.map(function(){
                var item = $($(this).attr('href'));
                if (item.length) { return item; }
              });
              
            $(window).scroll(function(){
                // Get container scroll position
                var fromTop = $(this).scrollTop()+topMenuHeight;
                // Get id of current scroll item
                var cur = scrollItems.map(function(){
                  if ($(this).offset().top < fromTop)
                    return this;
                });
                // Get the id of the current element
                cur = cur[cur.length-1];
                var id = cur && cur.length ? cur[0].id : "";
                
                if (lastId !== id) {
                    lastId = id;
                    // Set/remove active class
                    menuItems
                      .parent().removeClass("is-active")
                      .end().filter("[href='#"+id+"']").parent().addClass("is-active");
                }                   
            });
          }
          else{
            menuItems.click(function (e){
              var findid =$(this).attr('href');
              offsetTop = $(findid).offset().top;
              $('html, body').stop().animate({
                  scrollTop: offsetTop
              });
              return false;
            });
          }
          
          $productThumbsWrapper.slick({
            accessibility: false,
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  vertical: false,
                  verticalSwiping: false,
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  dots: true,
                }
              }
            ]
          }).css('opacity','1');
        }
        else{
          $productThumbsWrapper.slick({
            accessibility: false,
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 4
          }).css('opacity','1');
        }

        // Show highlighted thumbnail by repositioning slider
        $productThumbsWrapper.slick(
          'slickGoTo',
          $productThumbsWrapper.find('.is-active').attr('data-slick-index'),
          true
        );
      }
    },

    _productSwipeInit: function(evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'swipeleft swiperight',
        function(event) {
          if (event.type === 'swipeleft') {
            self._goToNextThumbnail();
          }

          if (event.type === 'swiperight') {
            self._goToPrevThumbnail();
          }

          // Trigger click on newly requested thumbnail
          $(
            '.product-single__thumbnail-item[data-slick-index="' +
              self.settings.productThumbIndex +
              '"]'
          )
            .find('.product-single__thumbnail')
            .trigger('click');
          
        }
      );
    },
    _goToNextThumbnail: function() {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _goToPrevThumbnail: function() {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _initQtySelector: function() {
      this.$container.find('.product-form__quantity').each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function() {
      $(this.selectors.productImageWrappers).off(this.settings.namespace);
      $(this.selectors.productThumbs).off(this.settings.namespace);
      $(this.selectors.productThumbs).slick('unslick');
      if (this.ProductModal) {
        this.ProductModal.$modal.off(this.settings.namespace);
      }
    }
  });

  return Product;
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    dots: '.slick-dots',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');

    this.settings = {
      rtl:theme.rtl,
      accessibility: true,
      arrows: true,
      dots: true,
      fade: (theme.rtl? false:true),
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

//     this.$wrapper.on('keyup', keyboardNavigation.bind(this));
//     this.$controls.on('keyup', keyboardNavigation.bind(this));
//     this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');

    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

//   function keyboardNavigation() {
//     if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
//       this.$slideshow.slick('slickPrev');
//     }
//     if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
//       this.$slideshow.slick('slickNext');
//     }
//   }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.Cart = (function() {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function() {
      $(selectors.cartQtyInput).each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function() {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function() {
        $(this)
          .css('height', 'auto')
          .css('height', $el[0].scrollHeight + noteOffset);
      });

      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        'change',
        $.proxy(function() {
          noteText = $el.val();
          params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + this._attributeToString(noteText),
            dataType: 'json'
          };
          $.ajax(params);
        }, this)
      );
    },

    _attributeToString: function(attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

// Instagrams
theme.Instagrams = (function() {
  function Instagrams(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    //console.log(this.$container);
    this.settings = {
      style 			: this.$container.data('style'),
      accesstoken 		: this.$container.data('accesstoken'),
      userid			: this.$container.data('userid'),
      limit 			: this.$container.data('limit'),
      resolution 		: this.$container.data('resolution'),
      target 			: this.$container.attr('id'),
      rows 			: this.$container.data('rows'),
      
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      draggable 		: this.$container.data('draggable') || false,
      dots 				: this.$container.data('dots') || false,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= 2;
    
    var _self = this;
    var $instagramSelector = $('#'+this.settings.target);
    if (this.settings.style === 'grid'){
      var afterInstagram = function(){} // blank function
    }else if (this.settings.style === 'carousel'){
      var afterInstagram = function(){
        $instagramSelector.slick({
          slidesToShow		: _self.settings.slidesToShow,
          slidesToScroll	: _self.settings.slidesToShow,
          arrows			: _self.settings.arrows,
          dots				: _self.settings.dots,
          draggable		 	: _self.settings.draggable,
          infinite		 	: _self.settings.infinite,
          rows : _self.settings.rows,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow	: _self.settings.slidesToShow1200,
                slidesToScroll	: _self.settings.slidesToShow1200,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow	: _self.settings.slidesToShow992,
                slidesToScroll	: _self.settings.slidesToShow992,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow	: _self.settings.slidesToShow768,
                slidesToScroll	: _self.settings.slidesToShow768,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow	: _self.settings.slidesToShow480,
                slidesToScroll	: _self.settings.slidesToShow480,
              }
            }
          ]
        })
      }
    }

    var feed = new Instafeed({
      get			: 'user',
      target 		: this.settings.target,
      userId		: this.settings.userid,
      accessToken	: this.settings.accesstoken,
      limit			: this.settings.limit,
      resolution	: this.settings.resolution,
      template		: '<div class="col hv-image-brightness"><a class="instagram-item" href="{{link}}" target="_blank" id="{{id}}"><img alt="instagram image" class="transition lazyload" data-src="{{image}}" /></a></div>',
      after			: afterInstagram
    });

    feed.run();
  }

  Instagrams.prototype = _.assignIn({}, Instagrams.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Instagrams;
})();

// Slick carousel
theme.slickCarousel = (function (){
  function Carousels(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      rows 				: this.$container.data('rows') || 1,
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      slidesToScroll	: this.$container.data('slidestoscroll') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      autoplay 			: this.$container.data('autoplay') || false,
      draggable 		: this.$container.data('draggable') || false,
      accessibility 	: this.$container.data('accessibility') || true,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= (this.settings.slidesToShow - 4) > 1? (this.settings.slidesToShow - 4) : 1;
    this.settings.slidesToScroll1200 	= (this.settings.slidesToScroll - 1) > 1? (this.settings.slidesToScroll - 1) : 1;
    this.settings.slidesToScroll992  	= (this.settings.slidesToScroll - 2) > 1? (this.settings.slidesToScroll - 2) : 1;
    this.settings.slidesToScroll768  	= (this.settings.slidesToScroll - 3) > 1? (this.settings.slidesToScroll - 3) : 1;
    this.settings.slidesToScroll480  	= (this.settings.slidesToScroll - 4) > 1? (this.settings.slidesToScroll - 4) : 1;
    this.$container.slick({
      rtl				: theme.rtl,
      rows 				: this.settings.rows,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll 	: this.settings.slidesToScroll,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      autoplay			: this.settings.autoplay,
      accessibility		: this.settings.accessibility,
      draggable			: this.settings.draggable,
      infinite			: this.settings.infinite,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: this.settings.slidesToShow1200,
            slidesToScroll: this.settings.slidesToScroll1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: this.settings.slidesToShow992,
            slidesToScroll: this.settings.slidesToScroll992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: this.settings.slidesToShow768,
            slidesToScroll: this.settings.slidesToScroll768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: this.settings.slidesToScroll480
          }
        }
      ]
    })
  }

  Carousels.prototype = _.assignIn({}, Carousels.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
    
    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.carousel__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
      
    }
  });

  return Carousels;
})()

// Productlists
theme.Productlists = (function() {
  function Productlists(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      rows 				: this.$container.data('rows') || 1,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      draggable 		: this.$container.data('draggable') || false,
      infinite 			: this.$container.data('infinite') || false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 2;
    this.$container.slick({
      rtl				: theme.rtl,
      accessibility		: true,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll	: this.settings.slidesToShow,
      rows				: this.settings.rows,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      infinite 			: this.settings.infinite,
      draggable			: this.settings.draggable,
      responsive		: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow	: this.settings.slidesToShow1200,
            slidesToScroll	: this.settings.slidesToShow1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow	: this.settings.slidesToShow992,
            slidesToScroll	: this.settings.slidesToShow992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow	: this.settings.slidesToShow768,
            slidesToScroll	: this.settings.slidesToShow768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow	: this.settings.slidesToShow480,
            slidesToScroll	: this.settings.slidesToShow480
          }
        }
      ]
    }).css('opacity','1');
  }

  Productlists.prototype = _.assignIn({}, Productlists.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    }
  });

  return Productlists;
})();

// Producttabs
theme.Producttabs = (function() {
  function Producttabs(container) {
    var _self = this; // avoid conflict
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.slickWrap 	= '.prdtab-content';
    this.settings 	= {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      arrows 			: this.$container.data('arrows') || false,
      rows 				: this.$container.data('rows') || 1,
      dots 				: this.$container.data('dots') || false,
      draggable			: this.$container.data('draggable') || false,
      infinite			: this.$container.data('infinite') || false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 2;

    this._initSlick();
    this.$container.find('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
      _self._unSlick();
      _self._initSlick();
      theme.tooltip.load();
    })
  }

  Producttabs.prototype = _.assignIn({}, Producttabs.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _getSliderSettings : function (){
      return {
        rtl				: theme.rtl,
        accessibility	: true,
        slidesToShow	: this.settings.slidesToShow,
        slidesToScroll	: this.settings.slidesToShow,
        arrows			: this.settings.arrows,
        rows			: this.settings.rows,
        dots			: this.settings.dots,
        infinite 		: this.settings.infinite,
        draggable		: this.settings.draggable,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: this.settings.slidesToShow1200,
              slidesToScroll: this.settings.slidesToShow1200
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: this.settings.slidesToShow992,
              slidesToScroll: this.settings.slidesToShow992
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: this.settings.slidesToShow768,
              slidesToScroll: this.settings.slidesToShow768
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: this.settings.slidesToShow480,
              slidesToScroll: this.settings.slidesToShow480
            }
          }
        ]
      }
    },

    _initSlick : function (){
      this.$container.find(this.slickWrap).slick(this._getSliderSettings()).css('opacity','1');
    },

    _unSlick : function(){
      this.$container.find(this.slickWrap).slick('unslick');
    },

    onUnload: function() {
      delete this.$container;
    },

    onSelect: function() {
      this._unSlick();
      this._initSlick();
    },

    onBlockSelect: function(evt) {
      var navItem = $('.nav-link-' + evt.detail.blockId);
      navItem.tab('show');
      this._unSlick();
      this._initSlick();
    }
  });

  return Producttabs;
})();

theme.Video = (function() {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function() {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function(defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function() {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly."
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function() {
            defer.resolve(player);
          });

          setTimeout(function() {
            defer.reject(
              'Request for YouTube player has timed out after 30 seconds.'
            );
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function() {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function(defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function() {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function() {
            defer.reject(
              'Request for Vimeo player has timed out after 30 seconds.'
            );
          }, 30000);

          player.ready().then(function() {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function() {
      this.$container
        .on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on('click', selectors.closePlayerButton, this._closePlayer.bind(this))
        .on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function() {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function(container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr('data-video-id'),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0
          }
        })
        .then(
          function(player) {
            this.player = player;
          }.bind(this)
        );
    },

    _loadVimeoPlayer: function(container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr('data-video-id')
        })
        .then(
          function(player) {
            this.player = player;
            this.player.play();
          }.bind(this)
        );
    },

    _onPlayerLoadReady: function() {
      $(selectors.closePlayerButton, this.$container)
        .show()
        .focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on(
        'resize' + this.namespace,
        this._setScrollPositionValues.bind(this)
      );
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function(err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function(evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function() {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
          this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function() {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function() {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
})();

theme.CollectionsList = (function() {
  function CollectionsList(container) {
    var $container = (this.$container = $(container));
    var stretchImage = $container.is('[data-stretch-image]');

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = (this.namespace = '.' + $container.attr('data-section-id'));
    var self = this;

    self._collectionListFix();
    $(window).on(
      'resize' + namespace,
      $.debounce(250, function() {
        self._collectionListFix();
      })
    );
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function() {
      $(window).off(this.namespace);
    },

    _collectionListFix: function() {
      var numberRows = this.$container.find('.grid').data('number-rows');
      var $featureCards = this.$container.find('.featured-card');

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is('[data-stretch-image]')) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter(
          "[data-row-number='" + (i + 1) + "']"
        );
        var $cardHeaders = $currentRow.find('.featured-card__header');

        // Find the max heights for each row
        $currentRow.each(function() {
          var $cardTitle = $(this).find('.featured-card__title');
          var $cardAction = $(this).find('.featured-card__action');
          var $cardImageWrapper = $(this).find('.featured-card__image-wrapper');
          var headerHeight =
            $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    }
  });

  return CollectionsList;
})();

theme.ParrallaxImage = (function() {
  function ParrallaxImage(container) {
    this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = 'parallax-' + this.sectionId;
      var images =  document.getElementsByClassName('thumbnail'+ this.sectionId);
      new simpleParallax(images,{
        scale: 1.5,
        delay: .6,
      });
  }

  ParrallaxImage.prototype = $.extend({}, ParrallaxImage.prototype, {
    onUnload: function(evt) {
      var instance = new simpleParallax(images);
      instance.destroy();
      delete theme.ParrallaxImage[this.namespace];
    }
  });

  return ParrallaxImage;
})();

theme.init = function() {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });


    //scroll animation
  AOS.init({
    startEvent: 'DOMContentLoaded',
    offset: 30, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1000,
    once: true
  });
  window.addEventListener('load', function() {
    AOS.refresh();
  });


  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('cart', theme.Cart);
  sections.register('instagrams', theme.Instagrams);
  sections.register('masonries', theme.Masonry);
  sections.register('productlist', theme.Productlists);
  sections.register('producttab', theme.Producttabs);
  sections.register('slickCarousels', theme.slickCarousel);
  sections.register('video', theme.Video);
  sections.register('collections-list', theme.CollectionsList);
  sections.register('parallax-image', theme.ParrallaxImage);
  sections.register('bgcollection', theme.Bgcollection);
  sections.register('textanimation',theme.HoverMenu);

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function() {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function(i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function() {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

// CSS var ponyfill
theme.cssVar = (function() {
  cssVars();
})()

// Ajax search https://gist.github.com/awojtczyk/53d74c8af5f893841f33979b0cdcd6fe
theme.ajaxSearch = (function() {
  var $inputSearch = '.js-ajaxsearch',
      $resultsList = '.search-results',
      $input = $($inputSearch).find('input[name="q"]'),
      $currentAjaxRequest,
      $displayProducts = 6;

  $($inputSearch).css('position', 'relative').each(function() {
    $input.attr('autocomplete', 'off').bind('keyup change', function() {
      var term = $(this).val(),
          form = $(this).closest('form'),
          searchURL = '/search?type=product&q=*' + term + '*';
      if (term.length > 2 && term !== $(this).attr('data-old-term')) {
        $(this).attr('data-old-term', term);
        if ($currentAjaxRequest !== undefined) $currentAjaxRequest.abort();
        $currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          $($resultsList).empty();

          if (data.results_count === 0) {
            $($resultsList).html('<p class="text-center">'+ theme.strings.ajaxSearchNoResult +'</p>')
          } else {
            $.each(data.results, function(index, item) {
              if (index < $displayProducts){
                var itemPrice = theme.Currency.formatMoney(item.price, theme.moneyFormat);
                var link = $('<a class="d-inline-flex '+index+'"></a>')
                .attr('href', item.url)
                .append('<span class="image"><img src="' + item.thumbnail + '" /></span>')
                .append('<div class="meta"><p class="title">' + item.title + '</p>'+itemPrice+'</div>')
                .wrap('<div class="ajax-search-item"></div>');
                $($resultsList).append(link.parent());
                theme.updateCurrencies();
              }
            });
            if (data.results_count > $displayProducts) {
              $($resultsList).append('<a class="btn btn--full" href="' + searchURL + '">'+ theme.strings.ajaxSearchViewAll +' (' + data.results_count + ')</a>');
            }
          }
          $($resultsList).addClass('active').fadeIn(200);
        });
      }
    });
  });

  //escape when click somethings
  $(document).click(function(event) {
    var target = event.target;
    if (!$(target).is($inputSearch) && !$(target).parents().is($inputSearch)) {
      $($resultsList).slideUp(300);
    }
  });
})();

// Quickview https://github.com/kellyvaughn/quickview-for-shopify/blob/master/quickview.js.liquid
theme.quickview = (function() {
  var product_handle = '',
      quickviewButtonClass = '.js-btn-quickview',
      quickviewId = '#jsQuickview',
      quickviewOption = '#jsQuickview select',
      quickviewThumb = '#qv-product-images',
      quickviewAddCartButton = '.qv-add-button',
      quickviewPrice = '.qv-product-price',
      quickviewComparePrice = '.qv-product-compare-price';

  // 1. Show quickview
  $(document).on('click',quickviewButtonClass, function() {
    product_handle = $(this).data('handle');
    //ResetQuickview
    $(quickviewId).removeClass().addClass('modal fade');
    $(quickviewThumb).removeClass().empty();
    $('.qv-product-options').empty();

    //Pushdata
    $(quickviewId).addClass(product_handle).data('handle',product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      var title = product.title;
      var type = product.type;
      var vendor = product.vendor;
      var price = 0;
      var compare_price = 0;
      var desc = product.description.slice(0, 90);
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.qv-view-product').attr('href', url);
      $('.qv-view-type').text(type);
      $('.qv-view-vendor').text(vendor)
      $(product.variants).each(function(i,variants) {
        if(variants.sku != null){
          $('.qv-sku').addClass("show").removeClass("hide");
          $('.qv-view-sku').text(product.variants[0].sku);
        }
        else{
          $('.qv-sku').addClass("hide").removeClass("show");
        }
        
      });
      var imageCount = $(images).length;
      $(images).each(function(i, image) {
        image_embed = '<div><img src="' + image + '"></div>';
        image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
        $(quickviewThumb).append(image_embed);
      });
      $(quickviewThumb).slick({
        rtl:theme.rtl,
        'dots': true,
        'arrows': true,
        'respondTo': 'min',
        'useTransform': true
      }).css('opacity', '1');

      if (product.variants[0].option1 !== "Default Title"){
        $(options).each(function(i, option) {
          var name = option.name;
          var opt = name.replace(/ /g, '-').toLowerCase();
          var selectClass = '.option.' + opt;
          $('.qv-product-options').append('<div class="option-selection ' + opt + '"><span class="option text-uppercase font-weight-bold text-body">' + option.name + '</span><select class="option-' + i + ' option ' + opt + '"></select></div>');
          $(option.values).each(function(i, value) {
            $('.option.' + opt).append($('<option>', {
              value: value,
              text: value
            }));
          });
        });
      }
      $(product.variants).each(function(i, v) {
        if (v.inventory_quantity == 0) {
          return true
        } else {
          price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          theme.updateCurrencies();
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });
    //addCartQuickview
  });
  // 2. Add to cart
  $(document).on('click',quickviewAddCartButton, function(){
    product_handle = $(quickviewId).data('handle');
    var qty = $('.qv-quantity').val(),
        selectedOptions = '',
        var_id = '';
    function processCart() {
      jQuery.post('/cart/add.js', {
        quantity: qty,
        id: var_id
      },null,"json").done(function(item) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var styleCart = $('.js-mini-cart').attr("data-cartmini");
        if(styleCart != 'true'){
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
        }
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();
      })
      .fail(function($xhr) {
        var data = $xhr.responseJSON;
        theme.alert.new('',data.description,3000,'warning');
      });
    }
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      if (product.variants.length === 1){
        var_id = product.variants[0].id;
      }else{
        $(product.variants).each(function(i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
          }
        });
      }
      processCart();
    });
  });
  // 3. Select variants
  $(document).on('change', quickviewOption, function() {
    var selectedOptions = '';
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      $(product.variants).each(function(i, v) {
        if (v.title == selectedOptions) {
          if (v.featured_image !== null){
            var iSlick = v.featured_image.position - 1;
            $(quickviewThumb).slick('slickGoTo', iSlick);
          }
          var price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          var compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          $(quickviewComparePrice).html(compare_price);
          if(v.sku != null){
            $('.qv-sku').addClass("show").removeClass("hide");
            $('.qv-view-sku').text(v.sku);
          }
          else{
            $('.qv-sku').addClass("hide").removeClass("show");
          }
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          theme.updateCurrencies();
          if (v.inventory_management === null) {
            $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
          } else {
            if (v.inventory_quantity < 1) {
              $(quickviewAddCartButton).prop('disabled', true).val(theme.strings.soldOut);
            } else {
              $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
            }
          }
        }
      });
    });
  });
})()

// Button add to cart (in grid item)
theme.addCartButton = (function(){
  var buttonClass = '.js-grid-cart';
  $(document).on('click',buttonClass,function(){
    var $this = $(this);
    var id = $this.data('id');
    $this.addClass('is-loading');
    Shopify.addItem(id,1,function(item){
      var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
      var styleCart = $('.js-mini-cart').attr("data-cartmini");
        if(styleCart != 'true'){
          var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        }
      theme.miniCart.updateElements();
      theme.miniCart.generateCart();
      setTimeout(function() {
        styleCart != 'true' ? theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice'): '';
        $this.removeClass('is-loading');
      }, 1000);
    });
  })
})()

// Multi currencies 
if (theme.enableCurrencies){
  // Can be 'money_format' or 'money_with_currency_format'
  Currency.format = 'money_format';
  var shopCurrency = Shopify.currency.active;
  var cookieCurrency = Currency.cookie.read();
  // Fix for customer account pages 
  jQuery('span.money span.money').each(function() {
    jQuery(this).parent('span.money').removeClass('money');
  });
  // Add precalculated shop currency to data attribute 
  jQuery('span.money').each(function() {
    jQuery(this).attr('data-currency-' + Shopify.currency.active, jQuery(this).html());
  });
  // Select all your currencies buttons.
  var buttons = jQuery('#currencies a'),
      currentCurrencies = jQuery('.pre-currencies');
  // When the page loads.
  if (cookieCurrency == null || cookieCurrency == shopCurrency) {
    Currency.currentCurrency = shopCurrency;
  }
  else {
    Currency.currentCurrency = cookieCurrency;
    Currency.convertAll(shopCurrency, cookieCurrency);
    buttons.removeClass('selected');
    jQuery('#currencies a[data-currency=' + cookieCurrency + ']').addClass('selected');
    var htmlCurrently = jQuery('#currencies a[data-currency=' + cookieCurrency + ']').html();
    currentCurrencies.html(htmlCurrently);
  }
  buttons.click(function() {
    buttons.removeClass('selected');
    jQuery(this).addClass('selected');
    var newCurrency =  jQuery(this).attr('data-currency');
    var htmlCurrently = jQuery(this).html();
    currentCurrencies.html(htmlCurrently);
    Currency.convertAll(Currency.currentCurrency, newCurrency);
  });
  // For product options.
  var original_selectCallback = window.selectCallback;
  var selectCallback = function(variant, selector) {
    original_selectCallback(variant, selector);
    Currency.convertAll(shopCurrency, jQuery('#currencies a.selected').attr('data-currency'));
  };
}
theme.updateCurrencies = function (){
  Currency.convertAll(shopCurrency, jQuery('#currencies a.selected').attr('data-currency'));
}

// MiniCart
theme.miniCart = (function(){
  var miniCart = '.js-mini-cart',
      styleCart = $(miniCart).attr("data-cartmini"),
      cartToggle = '.js-toggle-cart',
      cartCount = '.js-cart-count',
      cartContent = '.js-mini-cart-content',
      cartTotal = '.js-cart-total',
      $btnCheckout = $('.js-cart-btn-checkout'),
      numberDisplayed = 5,
      emptyCartHTML = '<div class="alert">'+theme.strings.cartEmpty+'</div>';

  function updateElements(){
    Shopify.getCart(function(cart){
      
      if (cart.item_count === 0) {
        $(cartContent).html(emptyCartHTML);
        $btnCheckout.addClass('disabled');
        styleCart === 'true' ? $(miniCart).removeClass('active') : null;
        
      }else{
        $btnCheckout.removeClass('disabled');
        styleCart === 'true' ? $(miniCart).addClass('active') : null;
      }
      $(cartCount).text(cart.item_count);
      $(cartTotal).html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
      theme.freeShipping.load(cart);
      theme.upsellingOffer.load(cart);
      theme.updateCurrencies();
    })
  }
  function generateCart(){
    
    Shopify.getCart(function(cart){
      var htmlCart = cart.item_count === 0? emptyCartHTML:'',
          itemCount = cart.items.length,
          // forLoop = itemCount < numberDisplayed ? itemCount : numberDisplayed;
          forLoop = itemCount
          //styleCart === 'true' ? cart.items.length ? $(miniCart).addClass('active'): $(miniCart).removeClass('active') :null;

      // add list items
      for (var i = 0; i < forLoop; i++) { 
        var product = cart.items[i],
            productPrice = theme.Currency.formatMoney(product.price, theme.moneyFormat);
        htmlCart += '<div class="mini-cart-item mini-cart-item-'+product.id+'">';
        htmlCart += '	<a class="mini-cart-image" href="'+ product.url +'">';
        htmlCart += '		<img src="'+ product.image +'"/>';
        htmlCart += '	</a>';
        htmlCart += '	<div class="mini-cart-meta">';
        htmlCart += '  <div>';
        htmlCart += '		<p><a href="'+ product.url +'" class="product_title">'+ product.product_title +'</a><br>';

        if(product.variant_title){
          htmlCart += '  <span class="variant_title">'+ product.variant_title +'</span>';
        }

        htmlCart += '   </p>';
        htmlCart += '		<div class="mini-cart-quantity">';
        htmlCart += '    <button type="button" class="js-mini-cart-update-qty" data-action="minus" data-item="'+product.id+'">-</button> ';
        htmlCart += '    <input type="number" data-item="'+product.id+'" class="js-mini-cart-update-qty-field mini-cart-item-qty-'+product.id+'" value="'+product.quantity+'" > ';
        htmlCart += '    <button type="button" class="js-mini-cart-update-qty" data-action="add" data-item="'+product.id+'">+</button></div>';
        htmlCart += '  </div>';
        htmlCart += '  <div class="right-meta"> <span>'+ productPrice+'</span>';
        htmlCart += '	  <button class="btn js-remove-mini-cart" data-id="'+product.id+'">Remove</button>';
        htmlCart += '  </div>';
        htmlCart += '	</div>';
        htmlCart += '</div>';
      }
      // if (itemCount > numberDisplayed){
      //   htmlCart += '<a class="js-btn-viewmore" href="/cart">'+theme.strings.cartMore+'('+(itemCount - numberDisplayed)+')</a>'
      // }
      // add total price and cart button / checkout button
      $(cartContent).html(htmlCart);
      $(cartTotal).html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
      theme.updateCurrencies();
    })
  }
  // 2. Button remove items
  $(document).on('click','.js-remove-mini-cart',function(){
    var itemId = $(this).data('id');
    var isOuterMiniCart = $(this).closest(miniCart).length === 0? true : false;  // check element from mini cart or not
    
    // hide items
    $('.mini-cart-item-' + itemId).fadeOut();
    
    //remove from cart
    Shopify.changeItem(itemId,0,function(){
      updateElements()
      generateCart()
    });
    // Shopify.getCart(function(cart){
    //   if (cart.items.length > numberDisplayed || isOuterMiniCart) {
    //     generateCart();
    //   }
    // });

  });

  $(document).on('keyup', '.js-mini-cart-update-qty-field', function(){
    const itemId = $(this).data('item')
    const itemQuantityField = $(this)
    let itemQuantity = itemQuantityField.val()

    if(itemQuantity <= 0){
      itemQuantity = 1
    }

    updateMiniCartItemQuantity(itemId, itemQuantity)
    
  })

  $(document).on('click', '.js-mini-cart-update-qty', function(){
    const action = $(this).data('action')
    const itemId = $(this).data('item')
    const itemQuantityField = $('.mini-cart-item-qty-' + itemId)
    let itemQuantity = itemQuantityField.val()
    if(action == 'add'){
      itemQuantity++
    }else if(action == 'minus'){  
      itemQuantity--
    }
  
    if(itemQuantity <= 0){
      itemQuantity = 1
      $(this).blur()
    }

    if(itemQuantity != itemQuantityField.val()){
      itemQuantityField.val(itemQuantity)
      updateMiniCartItemQuantity(itemId, itemQuantity)
    }
  })

  var updateMiniCartItemQuantity = debounce(function(itemId, itemQuantity){
    Shopify.changeItem(itemId, itemQuantity, function(){
      updateElements()
      generateCart()
    });
  })

  function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
  
  $(document).on('click', '.update_item_quantity', function(){
    const action = $(this).data('action')
    const key = $(this).data('key')
    const field = $('#Updates_' + key)
    let fieldValue = field.val()
    
    if(action == 'plus'){
      fieldValue++
    }else{
      fieldValue--
      if(fieldValue < 0){
        fieldValue = 0
      }
    }

    field.val(fieldValue)
    itemQuantityTriggerChange(field)
  })

  var itemQuantityTriggerChange = debounce(function(el){
    $(el).trigger('change')
  })

  //Keep popup when click cart / UX
  $(document).on('click',cartToggle,function(){
    $(this).parent(miniCart).toggleClass('active');
  });
  $(document).on('click','.overlaycart',function(){
    $(this).parent(miniCart).removeClass('active');
  });

  // gen minicart when load page
  generateCart();
  return{
    updateElements:updateElements,
    generateCart: generateCart
  }
})()

// Free shipping
theme.freeShipping = (function(){
  var $freeShippingClass = $('.js-free-shipping'),
      $freeShippingTextClass = $('.js-free-shipping-text'),
      minOrderValue = parseInt($freeShippingClass.data('value')) || 0,
      $percentClass = $('.js-free-shipping .progress-bar');

  function generate(cart){
    var priceCart = cart.total_price;
    if (priceCart >= minOrderValue){
      $percentClass.css('width','100%').removeClass('progress-bar-striped bg-primary');
      $freeShippingTextClass.text(theme.strings.freeShipping)
    }else{
      let percent = priceCart / minOrderValue * 100;
      let left = Shopify.formatMoney((minOrderValue - priceCart),theme.moneyFormat);
      $percentClass.css('width',percent+'%').addClass('progress-bar-striped primary');
      $freeShippingTextClass.html('Spend '+left+' for <b>FREE SHIPPING</b>');
      theme.updateCurrencies();
    }
  }

  Shopify.getCart(function(cart){
    generate(cart);
  });

  return {
    load:generate
  }
})()

// Shipping time - https://github.com/phstc/jquery-dateFormat
theme.shippingTime = (function(){
  var $shippingTime = $('.js-shipping-time'),
      shippingTime = $shippingTime.data('time') || '',
      now = new Date(),
      restHour = 23 - now.getHours(),
      restMinute = 59 - now.getMinutes();
  if (shippingTime !== ''){
    var nextTime = new Date(now.getTime() + shippingTime * 86400000),
        formatTime = $.format.date(nextTime, "ddd, dd MMMM yyyy"),
        htmlShipping = 'Order in the next <b>'+restHour+'</b> hours <b>'+restMinute+'</b> minutes to get it by <b>'+formatTime+'</b>. ';
    $shippingTime.html(htmlShipping);
  }
})()

// Infinite scroll - https://github.com/Elkfox/Ajaxinate/blob/master/dist/ajaxinate.min.js
theme.infiniteScroll = (function (){
  function initInfiniteScroll(){
    if ($('.AjaxinateLoop').length === 0){
      return;
    }else{
      var endlessScroll = new Ajaxinate({
        loadingText:'<div class="text-center"><div class="'+theme.loadingClass+'" role="status"></div></div>',
        callback:function(){
          theme.wishlist.load();
          theme.compare.load();
          theme.countdown.load();
          theme.priceRange.load();
          theme.tooltip.load();
          theme.collectionView.triggerView();
          theme.swatchCard2.load();
        }
      });
    }
  }
  
  // Infinite scroll in other page (blog, list-collection)
  function initOtherPages(){
    var otherPages = new Ajaxinate({
      loadingText:'<div class="text-center"><div class="'+theme.loadingClass+'" role="status"></div></div>',
      container: '.js-pagination-content',
      pagination: '.js-pagination'
    });
  }

  document.addEventListener("DOMContentLoaded", function(){
    initInfiniteScroll();
    initOtherPages();
  });

  return{
    load:initInfiniteScroll
  }
})()

// Scroll to fixed
theme.scrollToFixed = (function (){
  $('.js-stick-parent').stick_in_parent();
})()


theme.headersidebar = (function(){
  $('#dismiss, .overlaysidebar').on('click', function () {
    // hide sidebar
    $('#sidebar').removeClass('active');
    // hide overlay
    $('.overlaysidebar').removeClass('active');
  });
  
  $('#sidebarCollapse').on('click', function () {
    // open sidebar
    $('#sidebar').addClass('active');
    // fade in the overlay
    $('.overlaysidebar').addClass('active');
    $('.collapse.in').toggleClass('in');
    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
  });
})()

// Wishlist
theme.wishlist = (function (){
  var wishlistButtonClass = '.js-btn-wishlist',
      wishlistRemoveButtonClass = '.js-remove-wishlist',
      $wishlistCount = $('.js-wishlist-count'),
      $wishlistContainer = $('.js-wishlist-content'),
      wishlistObject = JSON.parse(localStorage.getItem('localWishlist')) || [],
      wishlistPageUrl = $('.js-wishlist-link').attr('href'),
      loadNoResult = function (){
        $wishlistContainer.html('<div class="col text-center"><div class="alert alert-warning d-inline-block">'+ theme.strings.wishlistNoResult + '</div></div>');
      };

  function updateWishlist(self) {
    var productHandle = $(self).data('handle'),
        allSimilarProduct = $(wishlistButtonClass+'[data-handle="'+productHandle+'"]');
    var isAdded = $.inArray(productHandle,wishlistObject) !== -1 ? true:false;
    if (isAdded) {
      // go to wishlist page
      window.location.href = wishlistPageUrl;
    }else{
      wishlistObject.push(productHandle);
      allSimilarProduct.fadeOut('slow').fadeIn('fast').html(theme.strings.wishlistIconAdded + theme.strings.wishlistTextAdded);
      //change tooltip
      allSimilarProduct.attr('data-original-title',theme.strings.wishlistTextAdded); 
      $('.tooltip-inner').text(theme.strings.wishlistTextAdded);
    }
    localStorage.setItem('localWishlist', JSON.stringify(wishlistObject)); 
    $wishlistCount.text(wishlistObject.length);
  };
  function loadWishlist(){
    $wishlistContainer.html('');
    //page wishlist
    if (wishlistObject.length > 0){
      for (var i = 0; i < wishlistObject.length; i++) { 
        var productHandle = wishlistObject[i];
        Shopify.getProduct(productHandle,function(product){
          var htmlProduct = '';
          var productPrice = product.price_varies? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat);
          var productComparePrice = product.compare_at_price_min !== 0? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '';
          htmlProduct += '<div class="js-wishlist-item col-md-4 col-sm-6 col-xs-6 col-12 mb-4">';
          htmlProduct += '<div class="js-wishlist-itembox">';
          htmlProduct += '<div class=" d-flex flex-row p-4">';
          htmlProduct += '	<a class="d-inline-block mr-4 " href="'+ product.url +'">';
          htmlProduct += '		<img src="'+ product.featured_image +'"/>';
          htmlProduct += '	</a>';
          htmlProduct += '	<div><a href=""'+ product.url +'" class="title-prouct d-block h4 text-body" >'+ product.title +'</a>';
          htmlProduct += '	<span> '+ productPrice +'</span>';
          htmlProduct += '	 <s>'+ productComparePrice +'</s></div>';
          htmlProduct += '<button class="btn js-remove-wishlist" data-handle="'+product.handle+'">'+ theme.strings.wishlistRemove +'</button>';
          htmlProduct += '</div>';
          htmlProduct += '</div>';
          htmlProduct += '</div>';
          $wishlistContainer.append(htmlProduct); 
          theme.updateCurrencies();
        });
      }
    }else{
      loadNoResult();
    }

    //count items
    $wishlistCount.text(wishlistObject.length);

    //button text
    $(wishlistButtonClass).each(function(){
      var productHandle = $(this).data('handle');
      var iconWishlist = $.inArray(productHandle,wishlistObject) !== -1 ? theme.strings.wishlistIconAdded : theme.strings.wishlistIcon;
      var textWishlist = $.inArray(productHandle,wishlistObject) !== -1 ? theme.strings.wishlistTextAdded : theme.strings.wishlistText;
      $(this).html(iconWishlist+textWishlist).attr('title',textWishlist);
    });
  }
  
  $(document).on('click',wishlistButtonClass,function (event) {
    event.preventDefault();
    updateWishlist(this);
  });
  $(document).on('click',wishlistRemoveButtonClass,function(){
    var productHandle = $(this).data('handle'),
    allSimilarProduct = $(wishlistButtonClass+'[data-handle="'+productHandle+'"]');
    
    //update button
    allSimilarProduct.html(theme.strings.wishlistIcon + theme.strings.wishlistText);
     //update tooltip
    allSimilarProduct.attr('data-original-title',theme.strings.wishlistText);
    $('.tooltip-inner').text(theme.strings.wishlistText);
    //update Object
    wishlistObject.splice(wishlistObject.indexOf(productHandle), 1);
    localStorage.setItem('localWishlist', JSON.stringify(wishlistObject)); 
    // Remove element
    $(this).closest('.js-wishlist-item').fadeOut(); // or .remove()
    //count
    $wishlistCount.text(wishlistObject.length);
    if (wishlistObject.length === 0) {
      loadNoResult();
    }
  });

  loadWishlist();
  $(document).on('shopify:section:load', loadWishlist);
  return{
    load:loadWishlist
  }
})()

// Compare
theme.compare = (function (){
  var compareButtonClass = '.js-btn-compare',
      compareRemoveButtonClass = '.js-remove-compare',
      $compareCount = $('.js-compare-count'),
      $compareContainer = $('.js-compare-content'),
      compareObject = JSON.parse(localStorage.getItem('localCompare')) || [],
      alertClass='notice';
  function updateCompare(self) {
    var productHandle = $(self).data('handle'),
        alertText = '';
    var isAdded = $.inArray(productHandle,compareObject) !== -1 ? true:false;
    if (isAdded) {
      compareObject.splice(compareObject.indexOf(productHandle), 1);
      alertText = theme.strings.compareNotifyRemoved;
      alertClass = 'notice';
    }else{
      if (compareObject.length === 4){
        alertText = theme.strings.compareNotifyMaximum;
        alertClass = 'error';
      }else{
        alertClass = 'notice';
        compareObject.push(productHandle);
        alertText = theme.strings.compareNotifyAdded;
      }
    }
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    theme.alert.new(theme.strings.compareText,alertText,2000,alertClass);
    $compareCount.text(compareObject.length);
  };
  function loadCompare(){
    var compareGrid;
    $compareContainer.html('');
    //popup compare
    if (compareObject.length > 0){
      compareGrid = compareObject.length === 1? 'col-md-6 col-sm-6' : 'col';
      for (var i = 0; i < compareObject.length; i++) { 
        var productHandle = compareObject[i];
        Shopify.getProduct(productHandle,function(product){
          var htmlProduct = '',
              productPrice = product.price_varies? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat),
              productComparePrice = product.compare_at_price_min !== 0 ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '',
              productAvailable = product.available ? theme.strings.available : theme.strings.unavailable,
              productAvailableClass = product.available ? 'alert-success' : 'alert-danger',
              productTypeHTML = product.type !== "" ? '<a href="/collections/types?q='+ product.type +'">'+ product.type +'</a>' : '<span>'+ theme.strings.none +'</span>',
              productVendorHTML = product.vendor !== "" ? '<a href="/collections/vendors?q='+ product.vendor +'">'+ product.vendor +'</a>' : '<span>'+ theme.strings.none +'</span>';
          htmlProduct += '<div class="compare-item '+compareGrid+' col-xs-6">';
          htmlProduct += '	<a href="'+ product.url +'">';
          htmlProduct += '		<img src="'+ Shopify.resizeImage(product.featured_image,'x300') +'"/>';
          htmlProduct += '	</a>';
          htmlProduct += '	<hr /><h5 >'+ product.title +'</h5>';
          htmlProduct += '	<hr /><s>'+ productComparePrice +'</s>';
          htmlProduct += '	<span> '+ productPrice +'</span>';
          htmlProduct += '	<hr /><span class='+ productAvailableClass +'> '+ productAvailable +'</span>';
          htmlProduct += '	<hr />'+ productTypeHTML;
          htmlProduct += '	<hr />'+ productVendorHTML;
          htmlProduct += '  <hr /><button class="btn js-remove-compare btn-theme gradient-theme" data-handle="'+product.handle+'">'+ theme.strings.compareRemove +'</button>';
          htmlProduct += '</div>';
          $compareContainer.append(htmlProduct);
          theme.updateCurrencies();
        });
      }
    }else{
      $compareContainer.html('<div class="alert alert-warning d-inline-block">'+ theme.strings.compareNoResult + '</div>');
    }
    
    //button text
    $(compareButtonClass).each(function(){
      var productHandle = $(this).data('handle');
      var status = $.inArray(productHandle,compareObject) !== -1 ? 'added' : '';
      $(this).removeClass('added').addClass(status);
    });

    //count items
    $compareCount.text(compareObject.length);
  }
  $(document).on('click',compareButtonClass,function (event) {
    event.preventDefault();
    updateCompare(this);
    loadCompare();
  });
  $(document).on('click',compareRemoveButtonClass,function(){
    var productHandle = $(this).data('handle');
    compareObject.splice(compareObject.indexOf(productHandle), 1);
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    loadCompare();
  });

  loadCompare();
  $(document).on('shopify:section:load', loadCompare);
  return{
    load:loadCompare
  }
})()

// Popup newsletter
theme.popupNewletter = (function(){
  var $popupNewsletter = $('#jsPopupNewsletter'),
      $newsletterForm = $('#jsPopupNewsletter form'),
      date = new Date(),
      minutes = theme.timePopupNewsletter;
  if ($popupNewsletter.length === 1){
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    var setCookies = function (){
      $.cookie('cookiesNewsletter', 'disabled', { expires: date, path: '/' } );
    };
    if ($.cookie('cookiesNewsletter') !== "disabled") {
      $(window).on('load',function(){
        $popupNewsletter.modal('show');
      });
      $popupNewsletter.on('hidden.bs.modal', setCookies);
      $newsletterForm.submit(setCookies);     
    }
  }
})()

// Cookie policy
theme.cookie = (function(){
  var $policy = $('.js-cookie-policy'),
      $closeButton = $('.js-btn-ok'),
      isOk = localStorage.getItem('localCookie') || '';
  if (isOk === ''){
    $policy.fadeIn('slow');
  }
  $closeButton.on('click',function(){
    localStorage.setItem('localCookie', 'accept');
    $policy.fadeOut('slow');
  })
})()

// Announcement Bar
theme.announcement = (function(){
  var $bar = $('.js-announcement-bar'),
      $closeButton = $('.js-ab-close'),
      isClosed = localStorage.getItem('localAnnouncement') || '';
  if (isClosed === ''){
    $bar.fadeIn();
    $bar.closest('.body-theme').addClass('body-announcement-bar');
  }
  $closeButton.on('click',function(){
    localStorage.setItem('localAnnouncement', 'closed');
    $bar.slideUp();
    $bar.closest('.body-theme').removeClass('body-announcement-bar');
  })
})()

// Banner Delivery Date Section
theme.bannerDeliveryDate = (function(){
  var $deliveryDateField = document.getElementById("delivery_date"),
      $deliveryDateSetBtn = '.js-delivery_set_btn',
      $isDateSet = sessionStorage.getItem('localBannerSetDelivery') || '';

    var dtToday = new Date();
    var monthToday = dtToday.getMonth() + 1;
    var dayToday = dtToday.getDate();
    var yearToday = dtToday.getFullYear();
    if(monthToday < 10)
        monthToday = '0' + monthToday.toString();
    if(dayToday < 10)
        dayToday = '0' + dayToday.toString();
    var maxDate = yearToday + '-' + monthToday + '-' + dayToday;
    $('#delivery_date').attr('min', maxDate);

  if ($isDateSet !== ''){
    $userDateSet = new Date($isDateSet);
    var year = $userDateSet.getFullYear();
    var month = (1 + $userDateSet.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = $userDateSet.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    monthIndex = parseInt(month);
    monthSelected = monthNames[monthIndex-1];
    
    $userDateSetString = month + '/' + day + '/' + year;
    $userDateSetWithMonthName = monthSelected + ' ' + day + ', ' + year;
    
    $('.delivery_date_saved > .date_entered').text($userDateSetString);
    $('#CartSpecialInstructions').text("Delivery Date: " + $userDateSetWithMonthName);
    
    $('.delivery_date_saved').addClass('show-item');
    if($('.delivery_date_saved').hasClass('scale-0')){
      $('.delivery_date_saved').removeClass('scale-0');
    }
    $('#delivery_date_input').addClass('hidden-item');
  }
  else {
    $('.delivery_date_saved').addClass('hidden-item');
    if(!$('.delivery_date_saved').hasClass('scale-0')){
      $('.delivery_date_saved').addClass('scale-0');
    }
    $('#delivery_date_input').addClass('show-item');
  }
  $(document).on('click',$deliveryDateSetBtn,function(){
    sessionStorage.setItem('localBannerSetDelivery', $deliveryDateField.value);
    location.reload()
  })

  
})()

// Banner Delivery Location Section
theme.bannerDeliveryLocation = (function(){
  if (Shopify.queryParams.city && Shopify.queryParams.zip){
    sessionStorage.setItem('localBannerSetDeliveryCity', Shopify.queryParams.city);
    sessionStorage.setItem('localBannerSetDeliveryZipCode', Shopify.queryParams.zip);
  }

  deliveryCity = sessionStorage.getItem('localBannerSetDeliveryCity') || '';
  deliveryZip = sessionStorage.getItem('localBannerSetDeliveryZipCode') || '';

  // else{
  //   window.location.href = 'https://dblooms.com';
  // }
  

  if (deliveryCity != ''){
    $('#js-banner-delivery-city').text(deliveryCity);
  }
  // else {
  //   newBannerDeliveryTitle = $('#js-banner-delivery-title').text().replace('to', 'from');
  //   $('#js-banner-delivery-title').text(newBannerDeliveryTitle);
  // }

  if (deliveryZip != ''){
    $('.js-banner-delivery-zip').text(deliveryZip);
  }

})();


// Header Change Initial Action
theme.headerDeliveryDetails = (function(){
  $(document).on('click',('.js-initialize-change-header-delivery'),function(){
    if($('.js-modal-change-delivery').hasClass("hidden-item")){
      $('.js-modal-change-delivery').removeClass("hidden-item")
    }
  })
})();


// Close Header Change Modal
theme.headerDeliveryDetails = (function(){
  $(document).on('click',('.js-modal-close-icon'),function(){
    if(!$('.js-modal-change-delivery').hasClass("hidden-item")){
      $('.js-modal-change-delivery').addClass("hidden-item")
    }
  })
})();


// Header Change Action
theme.headerDeliveryDetails = (function(){
  $(document).on('click',('.js-change-header-delivery'),function(){
    sessionStorage.setItem('localBannerSetDelivery', '');
    sessionStorage.setItem('localBannerSetDeliveryCity', '');
    sessionStorage.setItem('localBannerSetDeliveryZipCode', '');
    // location.reload()
  })
})();



// DB&Co back to Top Function
theme.dbcoBackToTop = (function(){
  $(".js-dbco-back-to-top").click(function () {
    $("html, body").animate({scrollTop: 0}, 1000);
 });
})();


// Open external link in new tab
theme.exLink = (function(){
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && $(links[i]).attr('href') !== 'javascript:void(0)' && !$(links[i]).hasClass('js-change-header-delivery')) {
      links[i].target = '_blank';
    }
  }
})()

// Deal- countdown
theme.countdown = (function(){
  function initCountdown(){
    $(".js-countdown").each(function() {
      var endTime = $(this).data('time'),
          htmlLayout = "<ul class='list--inline'><li class='gradient-theme-vertical'><span class='countdown-time'>%%D%%</span><span class='countdown-text'>Days</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%H%%</span><span class='countdown-text'>Hours</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%M%%</span><span class='countdown-text'>Mins</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%S%%</span><span class='countdown-text'>Secs</span></li></ul>";
      $(this).lofCountDown({
        TargetDate:endTime,
        DisplayFormat:htmlLayout,
        FinishMessage: '<span class="alert alert-warning d-inline-block">'+ theme.strings.countdownEndText +'</span>'
      });
    });
  }
  initCountdown();
  return{
    load:initCountdown
  }
})()

// Price range - Collection page
theme.priceRange =  (function (){
  function initPriceRange(){
    var min=0,
        max=0,
        slideRange = '#js-slider-range',
        productCard = '.js-product-card',
        slideRangeWrap = '.slider-range-wr',
        rangeMin = '.js-range-min',
        rangeMax = '.js-range-max',
        enablePriceRange = $('#js-slider-range').length === 1? true : false;

    if (enablePriceRange){
      $(productCard).each(function(){      
        if(eval($(this).data('price'))>max) max = eval($(this).data('price'));
        if(min==0) min = eval($(this).data('price')); else if(eval($(this).data('price'))<min) min =  eval($(this).data('price'));      
      });

      if (min === max){
        $(slideRangeWrap).fadeOut();
      }else{
        $(slideRangeWrap).fadeIn();
      }

      $(slideRange).slider({
        range: true,
        min: min,
        max: max,
        values: [ min, max ],
        slide: function(event,ui){
          var price1 = (Shopify.formatMoney(ui.values[0], theme.moneyFormat));
          var price2 = (Shopify.formatMoney(ui.values[1], theme.moneyFormat));
          $(rangeMin).html(price1);
          $(rangeMax).html(price2);
          theme.updateCurrencies();

          // Show/Hide product when dragging
          $(productCard).each(function() {
            if(eval($(this).data('price'))>= ui.values[0] && eval($(this).data('price'))<=ui.values[1]){
              $(this).parent().fadeIn();
            }else{
              $(this).parent().fadeOut();
            }
          });
        }
      });

      var price1 = (Shopify.formatMoney(min, theme.moneyFormat));
      var price2 = (Shopify.formatMoney(max, theme.moneyFormat));
      $(rangeMin).html(price1);
      $(rangeMax).html(price2);	  
      theme.updateCurrencies();

    }
  }
  initPriceRange();
  return{
    load:initPriceRange
  }
})()

// Collection view - Collection page
theme.collectionView =  (function (){
  var btnView = '.js-btn-view',
      btnViewActive = '.js-btn-view.active';

  $(document).on('click',btnView,function(){
    var value = $(this).data('col'),
        $gridItemCol = $('.js-col');

    $(btnView).removeClass('active');
    $(this).addClass('active');

    $gridItemCol.removeClass().addClass('js-col col-sm-6 col-6');
    if (value === 3){
      $gridItemCol.addClass('col-lg-4');
    }else if(value === 4){
      $gridItemCol.addClass('col-lg-3');
    }else if(value === 5){
      $gridItemCol.addClass('col-lg-2-4');
    }else if(value === 6){
      $gridItemCol.addClass('col-lg-2');
    };
  })

  function triggerCollectionView(){
    $(btnViewActive).trigger('click');
  }

  return {
    triggerView:triggerCollectionView
  }
})()

// Swath variant in card item
theme.swatchCard = (function(){
  $(document).on('click','.js-swatch-card-item',function(){//click or mouseover
    $(".js-swatch-card-item").removeClass("active");
    $(this).addClass("active");   
    var newImage = $(this).data('image');
    var id = $(this).data('id');
    var gridItem = $(this).closest('.js-product-card');
    gridItem.find('.product-card__image').find('img').attr('srcset',newImage);
    gridItem.find('.js-grid-cart').data('id',id).attr('data-id',id);
  });
})()

theme.swatchCard2 = (function(){
  function initVariant(id){
    var productJson = JSON.parse($('.customJson-' + id).html());
    var $selectorForm = $('.customform-' + id);
    var $button = $('.js-customform-addtocart-' + id);
    var $buttontext = $button.find('span');
    var $wrapObject = $selectorForm.closest('.js-product-card');
    var options = {
      $container: $selectorForm,
      enableHistoryState: false,
      product: productJson,
      singleOptionSelector: '.single-option-selector-' + id,
      originalSelectorId: '#ProductSelect-' + id
    };
    var variants = new slate.Variants(options);
    var AjaxCart = new window.AjaxCart($selectorForm);
    var _updateButton = function (evt){
      var variant = evt.variant;
      if (variant === undefined){
        $button.prop('disabled', true).removeClass('btn--sold-out');
        $buttontext.html(theme.strings.unavailable);
      }else{
        if (variant.available){
          $button.removeClass('btn--sold-out').prop('disabled', false);
          $buttontext.html(theme.strings.addToCart);
        }else{
          $button.prop('disabled', true).addClass('btn--sold-out');
          $buttontext.html(theme.strings.soldOut);
        }
      }
    }
    var _updateImage = function (evt){
      var variant = evt.variant;
      var $mainImage = $wrapObject.find('.product-card__image').find('img');
      if (variant !== undefined && variant.featured_image !== null){
        var variantImage = variant.featured_image;
        $mainImage.attr('srcset',variantImage.src);
      }
    }
    var _updatePrice = function (evt){
      var $price = $wrapObject.find('.product-card__price');
      var variant = evt.variant;
      if (variant !== undefined){
        var htmlComparePrice = variant.compare_at_price !== null ? '<s class="product-card__regular-price"><span class="money">'+variant.compare_at_price+'</span></s>' : '';
        var htmlPrice = '<span class="money">'+variant.price+'</span>' + htmlComparePrice ;
        $price.html(htmlPrice);
        theme.updateCurrencies();
      }
    }
    variants.$container.on(
      'variantChange' , _updateButton
    );
    variants.$container.on(
      'variantChange' , _updateImage
    );
    variants.$container.on(
      'variantChange' , _updatePrice
    );
  }
  function initForm(){
    $('.js-customform').each(function(){
      var id = $(this).data('id');
      initVariant(id);
    })
  }

  initForm();
  return{
    load:initForm
  }
})()

// Loading
theme.loading = (function(){
  var $loading = $('#js-loading'),
      hasLoading = $('#js-loading').length === 0? false : true;
  if (hasLoading){
    $(window).load(function () {
      $loading.fadeOut();
    });  
  }
})()

theme.effectLeavingPage = (function(){
  window.onbeforeunload = function(){
    $('body').css('opacity','0');
  }
})()

// Isotope
theme.isotope = (function(){
  var enableIsotope = $('.enable-isotope').length === 1 ? true : false,
      $grid = $('.js-grid'),
      filter = '.js-filter-isotope';

  function initIsotope(){
    if (enableIsotope){
      $grid.isotope({
        itemSelector: '.grid-item',
        percentPosition: true
      })
      $(document).on('click',filter,function(){
        var filterValue = $(this).data('filter') === '*'? $(this).data('filter') : '.' + $(this).data('filter');
        $(filter).removeClass('active');
        $(this).addClass('active');
        $grid.isotope({ 
          filter: filterValue 
        });
      });
      $(window).scroll(function() {
        $grid.isotope('layout');
      });
      $(window).load(function () {
        $grid.isotope('layout');
        $(filter).first().trigger('click');
      });
    }
  }
  initIsotope();
})()

//aos



// theme.Wow = (function(){
//   new WOW().init();
// })()




// Masonry
theme.Masonry = (function(){
  function Masonry(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    var $masonry = this.$container;
    $masonry.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer'
      }
    });
    $(window).load(function () {
      $masonry.isotope('layout').css('opacity','1');
    });
    $(window).scroll(function() {
      $masonry.isotope('layout').css('opacity','1');
    });
  }

  Masonry.prototype = _.assignIn({}, Masonry.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Masonry;
})();



// Cross-selling
theme.crosssell = (function(){
  var crosssellClass = '.js-crosssell',
      handles = $(crosssellClass).data('handles') || '',
      arrayHandle = handles.split(','),
      $blockCrosssell = $('.block-cross-sell'),
      variantSelectClass = '.js-cross-select',
      crossImageClass = '.cross-item-image',
      crossPriceClass = '.cross-item-money';  
  function generateCrosssell(){
    for (var i = 0; i < arrayHandle.length; i++) {
      var productHandle = arrayHandle[i];
      Shopify.getProduct(productHandle,function(product){
        var htmlCross = '',
            htmlOption = '',
            firstAvailableVariant = '',
            variantCount = product.variants.length;

        // generate select box and check first avaiable variant
        for (var j = 0; j < variantCount; j++){
          var variant = product.variants[j],
              variantImage = variant.featured_image === null? product.featured_image : variant.featured_image.src,
              disabled = variant.available ? '' : 'disabled';
          htmlOption += '<option '+disabled+' data-id="'+variant.id+'" data-price="'+variant.price+'" data-image="'+variantImage+'">'+variant.title+'</option>';
          if (firstAvailableVariant === '' && variant.available ){
            firstAvailableVariant = variant
          }
        }
        var productPrice = theme.Currency.formatMoney(firstAvailableVariant.price, theme.moneyFormat),
            productImage = firstAvailableVariant.featured_image === null? product.featured_image:firstAvailableVariant.featured_image.src,
            selectHide = variantCount === 1 ? 'hide' : '';

        // generate HTML
        htmlCross +='<div class="col cross-item '+product.handle+'">';
        htmlCross +='	<a class="cross-item-image" href="'+product.url+'" title="'+product.title+'"><img src="'+productImage+'" />'+theme.strings.cartIcon+'</a>';
        htmlCross +='	<a target="_blank" href="'+product.url+'" title="'+product.title+'" class="cross-item-title">'+product.title+'</a>';
        htmlCross +='	<span class="cross-item-money">'+productPrice+'</span>';
        htmlCross +='	<select class="js-cross-select '+selectHide+'" data-image="'+productImage+'" data-price="'+firstAvailableVariant.price+'" data-item="'+firstAvailableVariant.id+'">'+htmlOption+'</select>';
        htmlCross +='</div>';
        $(crosssellClass).append(htmlCross);
        theme.updateCurrencies();
      });
    }
  }
  
  function showPopupCrosssell(lineItem){
    //generate lineitem;
    var htmlLineItem = '';
    htmlLineItem += '<span class="alert alert-success d-inline-block mb-2">'+ theme.strings.addToCartSuccess +'</span>';
    htmlLineItem += '<div><img src="'+lineItem.image+'" alt="Added Product"></div>';
    htmlLineItem += '<h4 class="cross-item-title">'+lineItem.title+'</h4>';
    htmlLineItem += '<div class="mb-2">'+theme.strings.cartQuantity+': '+lineItem.quantity+'</div>';
    $('.js-cross-added').hide().html(htmlLineItem).fadeIn();

    // show popup
    var $popupCrosssell = $('#jsCrosssell');
    $popupCrosssell.modal('show');
  }

  if (handles !== '') {
    $(document).on('click',crossImageClass,function(event){
      event.preventDefault();
      var parent = $(this).closest('.cross-item'),
          itemId = parent.find(variantSelectClass).attr('data-item');
      Shopify.addItem(itemId,1,function(lineItem){
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();
        showPopupCrosssell(lineItem);
      });
    });
    $(document).on('change',variantSelectClass,function(){
      var selectVariant = $(this).children(':selected'),
          selectVariantId = selectVariant.data('id'),
          parent = $(this).parent(),
          newPrice = theme.Currency.formatMoney(selectVariant.data('price'), theme.moneyFormat);

      if (selectVariant.data('image') !== ''){
        parent.find(crossImageClass).find('img').attr('src',selectVariant.data('image'));
      }
      $(this).attr('data-item',selectVariantId);
      parent.find(crossPriceClass).html(newPrice);
      theme.updateCurrencies();
    });
    $(document).on('shopify:section:load', generateCrosssell);
    generateCrosssell();
    $blockCrosssell.removeClass('hide');
  }

  return{
    showPopup:showPopupCrosssell
  }
})()

// Upsell
theme.upsell = (function(){
  var popupUpsell = '#jsUpsell',
      $button = $('#jsUpsell .btn'),
      productUpsellId = $('#jsUpsell').data('id') || '',
      buttonAcceptClass = 'js-btn-accept',
      delayTime = $('#jsUpsell').data('delay') || 3000,
      isUpsell = $(popupUpsell).length === 1? true:false;
  if (isUpsell){
    $(document).ready(function() {
      setTimeout(function() {
        $(popupUpsell).modal('show');
      }, delayTime);
    });
    $button.on('click',function(){
      if($(this).hasClass(buttonAcceptClass)){
        Shopify.addItem(productUpsellId,1,function(item){
          theme.miniCart.updateElements();
          theme.miniCart.generateCart();
          var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
          var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
          theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
        })
      }
      $(popupUpsell).modal('hide');
    })
  }
})()

// Coupon
theme.coupon = (function(){
  var popupCoupon = '#jsCoupon',
      $button = $('#jsCoupon .js-btn-coupon'),
      delayTime = $('#jsCoupon').data('delay') || 3000,
      isCoupon = $(popupCoupon).length === 1? true:false,
      isCopied = localStorage.getItem('localCoupon') || '';
  if (isCoupon && isCopied === ''){
    $(document).ready(function() {
      setTimeout(function() {
        $(popupCoupon).modal('show');
      }, delayTime);
    });
    $button.on('click',function(){
      var copyText = document.getElementById("coupon_code");
      copyText.select();
      document.execCommand("Copy");
      $(popupCoupon).modal('hide');
      theme.alert.new('Coupon code','Successfully copied, now you can paste code at checkout',4000);
      localStorage.setItem('localCoupon', 'copied');
    })
  }
})()

// Overwrite Shopify.onError in Shopify API
Shopify.onError = function(t, r) {
    var e = eval("(" + t.responseText + ")");
    var mess = e.message ? e.message + "(" + e.status + "): " + e.description : "Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + "."
    theme.alert.new('Alert',mess,3000,'warning');
}

// Megamenu width
theme.fixWidthMegamenu = (function(){
  var $megamenuClass = $('.site-nav__item-mega'),
      megaDropdownClass = '.meganav';
  $megamenuClass.each(function(){
    var widthMenu = $(this).data('width') || 0;
    if (widthMenu !== 0){
      $(this).find(megaDropdownClass).css({'width':widthMenu+'px','margin-left':'-'+widthMenu/2+'px'});
    }
  });
})()

// Product video
theme.productVideo = (function(){
  var playButtonClass = '.js-play-button';
  $(document).on('click',playButtonClass,function(){
    let videoSelector = $(this).next(),
        videoObject = videoSelector.get(0);
    $(this).toggleClass('active');
    videoSelector.toggleClass('active');
    videoObject.paused ? videoObject.play() : videoObject.pause();
  })
})()

// Fake-viewers
theme.fakeViewer = (function(){
  var $fakeViewClass = $('.js-fake-view'),
      minValue = $fakeViewClass.data('min'),
      maxValue = $fakeViewClass.data('max'),
      duration = $fakeViewClass.data('duration');
  function randomInRange(start,end){
    var value = Math.floor(Math.random() * (end - start + 1) + start);
    $fakeViewClass.text(value);
  }

  if (minValue !== undefined && maxValue !== undefined){
    randomInRange(minValue,maxValue);
    setInterval(function() {
      randomInRange(minValue,maxValue);
    },duration);
  }

})();

// Product-suggest
theme.productSuggest = (function(){
  var $productSuggestClass = $('.product-notification'),
      $closeButtonClass = $('.close-notifi'),
      duration = $productSuggestClass.data('time') || 0,
      productSuggestCookie = 'cookieSuggest';

  function SomeonePurchased() {
    if ($.cookie(productSuggestCookie) == 'closed') {
      $productSuggestClass.remove();
    }
    $closeButtonClass.on('click',function(){
      $productSuggestClass.remove();
      $.cookie(productSuggestCookie, 'closed', {expires:1, path:'/'});
    });  
    function toggleSomething() {
      if($productSuggestClass.hasClass('active')){
        $productSuggestClass.removeClass('active')
      }
      else{
        var arrayProducts = $('.data-product'),
            randomProduct = Math.floor(Math.random() * arrayProducts.length),
            Object = $(arrayProducts[randomProduct]);

        $productSuggestClass.addClass('active');
        $productSuggestClass.find('.product-image').attr('href', Object.data('url')).find('img').attr('src', Object.data('image'));
        $productSuggestClass.find('.product-name').text(Object.data('title')).attr('href', Object.data('url'));
        $productSuggestClass.find('.time-ago').text(Object.data('time'));
        $productSuggestClass.find('.from-ago').text(Object.data('local'));
      }
    }

    if (duration !== 0){
      setInterval(toggleSomething, duration);
    }
  }
  SomeonePurchased();
})()


// Stickyheader
theme.stickyHeader = (function(){
  var stickHeaderClass = '.site-header--sticky';
  if ($(stickHeaderClass).length !== 0){
      var scrollNow = window.pageYOffset;
      var sticky = $(stickHeaderClass).offset().top + $(stickHeaderClass).height();

    $(window).scroll(function() {
      scrolled = window.pageYOffset;

      if (window.pageYOffset > sticky && window.pageYOffset < scrollNow) {
        $(stickHeaderClass).addClass('active');
      } else {
        $(stickHeaderClass).removeClass('active');
      }

      scrollNow = window.pageYOffset;
    });
  }
})()

theme.PhotoSwipe = (function(){
  var initPhotoSwipeFromDOM = function(gallerySelector) {

    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;

        for(var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes 
            if(figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element

            size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };



            if(figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML; 
            }

            if(linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            } 

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) { 
                continue; 
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if(index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {
          maxSpreadZoom: 1,
          bgOpacity: 0.7,
          zoomEl: true,
          history:false,
          zoomEl: false,
          pinchToClose: false,
          closeOnScroll:false,
            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

        };

        // PhotoSwipe opened from URL
        if(fromURL) {
            if(options.galleryPIDs) {
                // parse real index when custom PIDs are used 
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(var j = 0; j < items.length; j++) {
                    if(items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if( isNaN(options.index) ) {
            return;
        }

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll( gallerySelector );

    for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if(hashData.pid && hashData.gid) {
        openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
    }
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');
})()

theme.ZoomImage = (function(){
  $(window).resize(function() {
    var width = $(window).width();
    if (width > 767){
      ZoomImage();
    }
  });
  $(window).width(function() {
    var width = $(window).width();
    if (width > 767){
      ZoomImage();
    }
  });
  function ZoomImage(){
    $(".zoom_image").each(function(arg, el){
        var image = $(el).find("img");
        $(el).zoom({
            on: 'mouseover',
            url: image.attr("src").replace("small", "big")
        });
    });
  }
})()

theme.activeAccordion = (function(){
  $('.collapse').on('shown.bs.collapse', function () {
       $(this).prev().addClass('active-acc');
   });
   $('.collapse').on('hidden.bs.collapse', function () {
       $(this).prev().removeClass('active-acc');
   });
})()

theme.HoverMenu = (function () {
  function HoverMenu(container) { 
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var item = this.slider = '.item_' + sectionId;
      const items = document.querySelectorAll(item);
      var zoomout = false;

    items.forEach((el) => {
      const image = el.querySelector('.img')
      
      el.addEventListener('mouseenter', (e) => {
        gsap.to(image, {
          ease: 'Expo.easeOut',
          autoAlpha: 1,
          scale: 1,
          startAt: {
            scale: zoomout ? 1.2 :0.6,
          },
            scale: 1
        })
      })
      
      el.addEventListener('mouseleave', (e) => {
        gsap.to(image, {
          ease: 'Expo.easeOut',
          autoAlpha: 0,
          scale: zoomout ? 1.2 : 1,
        })
      })
      
      el.addEventListener('mousemove', (e) => {
        gsap.set(image, { 
          ease: 'Expo.easeOut',
          left: e.offsetX,
          top: e.offsetY,
          delay: 0,
        })
      })
    })
  }
  
  return HoverMenu;
})()



// Anchor scroll
theme.anchorScroll = (function(){
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    var disableAnchor = $(this).hasClass('disabled-anchor');
    if (!disableAnchor){
      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
      }, 500);
    }
  });
})()

// Product-recently-viewed
theme.productRecentlyViewed = (function(){
  var $viewedElement = $('.js-recently-view'),
      $viewButton = $('.js-recently-view-button'),
      $content = $('.js-recently-view-content'),
      productHandle = $viewedElement.data('handle') || '',
      limit = $viewButton.data('limit') || 0,
      arrayProduct = JSON.parse(localStorage.getItem('localRecentlyViewed')) || [],
      lastProduct = arrayProduct[arrayProduct.length - 1] || '',
      isAdded = $.inArray(productHandle,arrayProduct) !== -1 ? true:false;

  function processViewed(){
    if (productHandle !== ''){
      //process last product
      if (lastProduct === productHandle && arrayProduct.length > 1){
        lastProduct = arrayProduct[arrayProduct.length - 2]
      }

      //move current product to last of array
      if (isAdded){
        arrayProduct.splice(arrayProduct.indexOf(productHandle), 1);
      }
      arrayProduct.push(productHandle);
      //remove first item if limit
      if (arrayProduct.length > limit){
        arrayProduct.shift()
      }
      localStorage.setItem('localRecentlyViewed', JSON.stringify(arrayProduct));
    }
  }

  function generatorProduct(){
    $content.html('');
    if (arrayProduct.length > 0){
      //array
      for (var i = 0; i < arrayProduct.length; i++) {
        var productHandle = arrayProduct[i];
        Shopify.getProduct(productHandle,function(product){
          var htmlProduct = '';
          var productPrice = product.price_varies? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat);
          var productComparePrice = product.compare_at_price_min !== 0? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '';
          htmlProduct += '<div class="col-12 col-lg-4 js-viewed-item mb-4">';
          htmlProduct += '	<div class="border p-3 rounded media d-flex ">';
          htmlProduct += '	<a class="mr-3 col-4 p-0" href="'+ product.url +'">';
          htmlProduct += '		<img src="'+ product.featured_image +'"/>';
          htmlProduct += '	</a>';
          htmlProduct += '	<div class="media-body text-left">';
          htmlProduct += '		<h4 class="mb-2 mt-2">'+ product.title +'</h4>';
          htmlProduct += '	<span> '+ productPrice +'</span>';
          htmlProduct += '	<s>'+ productComparePrice +'</s>';
          htmlProduct += '	</div>';
          htmlProduct += '	</div>';
          htmlProduct += '</div>';
          $content.append(htmlProduct);
          theme.updateCurrencies();
        });
      }

      //last product
      Shopify.getProduct(lastProduct,function(product){
        $viewButton.css('background-image','url('+product.featured_image+')').addClass('active');
      })
    }
  }

  processViewed();
  generatorProduct();

})()

// Notice when soldout
theme.alert = (function(){
  function createAlert(title,mess,time,type){
    var aTitle = title || '',
        aTime = time || 2000,
        aMessage = mess || '',
        aClass = type || 'default';
    $.growl({ 
      title: aTitle,
      message: aMessage,
      duration: aTime,
      style: aClass,
      size: 'large'
    });
  }

  return{
    new:createAlert
  }
})()

// Notice when soldout
theme.noticeSoldout = (function(){
  var $soldoutWrapFormClass = $('.js-contact-soldout'),
      $textClass = $('.js-notify-text'),
      $soldoutValueId = $('#ContactProduct');
  function noticeSoldout(variant){
    $soldoutWrapFormClass.find('.form-success').remove()
    if (variant.available){
      $textClass.find('span').text('');
      $soldoutWrapFormClass.addClass('hide');
    }else{
      $textClass.find('span').text(': ' + variant.name);
      $soldoutWrapFormClass.removeClass('hide');
      $soldoutValueId.val(variant.name).attr('value',variant.name);
    }
  }
  return {
    init : noticeSoldout
  }
})()

// Sticky cart
theme.stickyCart = (function(){
  var $anchor = $('#js-anchor-sticky-cart'),
      $stCart = $('.sticky-cart-wr'),
      $close = $('#js-sticky-close'),
      disableStCart = localStorage.getItem('localDisableStCart') || '';
  if(disableStCart !== ''){
    $stCart.addClass('disable');
  }
  $close.on('click',function(){
    var isDisable = disableStCart !== '';
    if(isDisable){
      localStorage.setItem('localDisableStCart', '');
    }else{
      localStorage.setItem('localDisableStCart', 'true');
    }
    $stCart.toggleClass('disable');
  })
  if($anchor.length){
    $(window).on('scroll',function() {
      var hT = $anchor.offset().top,
          hH = $anchor.outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop();
      if (wS > (hT+hH-wH)){
        $stCart.addClass('active');
      }else{
        $stCart.removeClass('active');
      }
    });
  }
  
})()

// Back to top
theme.backToTop = (function(){
  var backtotopClass = $('.js-back-to-top');
  $(window).scroll(function() {
    if ($(this).scrollTop() > 300) {
      backtotopClass.fadeIn('slow');
    } else {
      backtotopClass.fadeOut('slow');
    }
  });
  backtotopClass.on('click',function(){
    $('body,html').animate({scrollTop: 0}, 800);
  });
})()


// Tooltip
theme.tooltip = (function(){
  var selector = '[data-toggle="tooltip"],[data-tooltip="true"]';
  function loadTooltip(){
    $(selector).tooltip(); //Bootstrap 4
  };
  $(document).on('click',selector,function(){
    $(this).tooltip('hide');
  });
  loadTooltip();
  return{
    load:loadTooltip
  }
})()

//Collections style 2
theme.Bgcollection = (function(){
  // init Isotope
    function Bgcollection(container){
     var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');
     var wrapper = this.wrapper = '.bgcollection-wrapper';
     var slider = this.slider = '#Bgcollection-' + sectionId;
     var $slider = $(slider, wrapper);
     $(".colgrid__bg--full[data-index='1']").addClass('active');
     $('.colgrid .colgrid__box').each(function(){
           var index = $(this).attr("data-index");
           $(this).hover(
           function() {
              $(".colgrid__bg--full[data-index='"+index+"']").addClass('active');
           }, 
           function() {
                 $(".colgrid__bg--full[data-index='"+index+"']").removeClass('active');
              }
           );
        });
      }
    
    return Bgcollection;
  })();
  

//Sidebar
theme.sidebar = (function(){
  var togglebutton = '.js-toggle-filter',
      $sidebar = $('.js-sidebar');
  $(document).on('click',togglebutton,function(){
    $sidebar.toggleClass('active');
    $(this).toggleClass('active');
  })
})()

// Ajax filter in collection page
theme.ajaxFilter = (function() {
  var ajaxContent = '#js-product-ajax',
      ajaxSortBy = '#js-sortby',
      ajaxFillter = '#js-fillter',
      ajaxCollectionTitle = '.js-collection-title',
      pageTitle = $(document).find("title").text(),
      jsLoading = '#js-loading';

  var apollo = {
    init: function() {
      this.initFilter(); 
    },
    showLoading: function() {
      $(jsLoading).show();
    },
    hideLoading: function() {
      $('body,html').animate({
        scrollTop: $(ajaxContent).offset().top
      }, 600);
      setTimeout(function(){
        $(jsLoading).hide(); //delay 500ms for better UX
      }, 500); 
     
    },
    initFilter: function() {
      apollo.filterParams();
      apollo.filterSortby();
      apollo.sidebarMapTagEvents();
      apollo.filterMapSorting();
      apollo.filterMapPaging();
      apollo.filterMapAll();
      apollo.filterRemoveFilters();
    },
    filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },
    filterSortby: function() {
      if (Shopify.queryParams.sort_by) {
        var sortby = Shopify.queryParams.sort_by;
        $(ajaxSortBy).val(sortby);
      }
    },
    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {
        if (newQuery != "") {
          return baseLink + "?" + newQuery;
        } else {
          return baseLink;
        }
      }
      return location.pathname + "?" + newQuery;
    },
    filterMapData: function(data) {
      // 1. update product grid
      $(ajaxContent).html($(ajaxContent, data.responseText).html());
      // 2. update left filter
      $(ajaxFillter).html($(ajaxFillter, data.responseText).html());
      // 3. update collection title
      $(ajaxCollectionTitle).html($(ajaxCollectionTitle, data.responseText).html());
    },
    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = apollo.filterCreateUrl(baseLink);
      History.pushState({
        param: Shopify.queryParams
      }, pageTitle, newurl);
      apollo.filterGetContent(newurl);
    },
    filterGetContent: function(newurl) {
      $.ajax({
        type: 'GET',
        url: newurl,
        data: {},
        beforeSend: function() {
          apollo.showLoading();
        },
        complete: function(data) {
          apollo.filterMapData(data);
          theme.wishlist.load();
          theme.compare.load();
          theme.countdown.load();
          theme.priceRange.load();
          theme.tooltip.load();
          theme.collectionView.triggerView();
          theme.swatchCard2.load();
          theme.infiniteScroll.load();
          apollo.hideLoading();
        },
        error: function(xhr, text) {
          apollo.hideLoading();
          alert($.parseJSON(xhr.responseText).description);
        }
      });
    },
    sidebarMapTagEvents: function() {
      $(document).on('click','.advanced-filter a',function(event){
        event.preventDefault();
        $('.tooltip').removeClass('show');
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }
        if (!$(this).parent().hasClass("active-filter")) {
          var otherTag = $(this).parents('.catalog_filter_ul').find("li.active-filter");
          if (otherTag.length > 0) {
            var tagName = otherTag.data("handle");
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
              }
            }
          }
        }
        var dataHandle = $(this).parent().data("handle");
        if (dataHandle) {
          var tagPos = currentTags.indexOf(dataHandle);
          if (tagPos >= 0) {
            currentTags.splice(tagPos, 1);
          } else {
            currentTags.push(dataHandle);
          }
        }
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        apollo.filterAjaxClick();
        apollo.filterRemoveFilters();

      });
      $(document).on('click','.advanced-filter .icon-circle',function(){
        $(this).parent('.advanced-filter').find('a').trigger( "click" );
      });
    },
    filterMapSorting: function() {
      $(document).on('change',ajaxSortBy,function(){
        Shopify.queryParams.sort_by = $(this).val();
        apollo.filterAjaxClick();
      })
    },
    filterMapPaging: function() {
      $(document).on('click','.js-pagination a',function(){
        event.preventDefault();
        var linkPage = $(this).attr("href").match(/page=\d+/g);
        if (linkPage) {
          Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
          if (Shopify.queryParams.page) {
            var newurl = apollo.filterCreateUrl();
            History.pushState({
              param: Shopify.queryParams
            }, pageTitle, newurl);
            apollo.filterGetContent(newurl);
          }
        }
      });
    },
    filterMapAll: function(){
      $(document).on('click', '.js-remove-filter-constraint', function(){
        constraintItems = Shopify.queryParams['constraint'].split('+');
        processedConstraintItems = [];

        constraintItems.forEach(function(item, index){
          item = item.charAt(0).toUpperCase() + item.slice(1);
          item = item.replaceAll('-', ' ');
          processedConstraintItems.push(item)
        });
        
        const constraintValue = this.childNodes[0].nodeValue.trim();
        const constraintValueIndex = processedConstraintItems.indexOf(constraintValue);

        if (constraintValueIndex > -1) {
          constraintItems.splice(constraintValueIndex, 1);
        }

        if (constraintItems.length) {
          delete Shopify.queryParams.constraint;
          Shopify.queryParams.constraint = constraintItems.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }        

        apollo.filterAjaxClick();
        apollo.filterRemoveFilters();

      })

      $(document).on('click', '.js-remove-filter-price', function(){
        theme.priceRange;
        apollo.filterAjaxClick();
        apollo.filterRemoveFilters();

      })

      $(document).on('click', '.js-filter-clear', function(){
        theme.priceRange;
        Object.keys(Shopify.queryParams).map(function(key){
          delete Shopify.queryParams[key];
        })
        apollo.filterAjaxClick();
        apollo.filterRemoveFilters();
      })

    },
    filterRemoveFilters: function(){
      $('.js-clear-filters').empty();

      removeFilterIcon = `
          <span class='remove-filter-icon'>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.14398 0.963867L4.96173 4.14537L1.78023 0.963867L0.719727 2.02437L3.90123 5.20587L0.719727 8.38737L1.78023 9.44787L4.96173 6.26637L8.14398 9.44787L9.20448 8.38737L6.02298 5.20587L9.20448 2.02437L8.14398 0.963867Z" fill="white"/>
          </svg>
          </span>
          `
    
      Object.keys(Shopify.queryParams).map(function(key){
        removeFilterContents = Shopify.queryParams[key].split('+');
        for(var item of removeFilterContents){
          if (key=='constraint'){
            item = item.charAt(0).toUpperCase() + item.slice(1);
            item = item.replaceAll('-', ' ');
            text = $('.js-clear-filters').append('<label for="filterTags-'+item +'" class="js-remove-filter-constraint js-remove-filter-btn">'+item+removeFilterIcon+'</label>'); 
          }
        };
        
    });


    if($('.js-clear-filters').children().length > 0){
      text = $('.js-clear-filters').append('<span class="js-filter-clear">Clear All</span>'); 
    }
    }
  }

  if ($(".template-collection")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      apollo.filterParams();
    });
  }
  apollo.init();
  
})();

// Sticky Filter Row
theme.filteringScroll = (function(){
  var stickFilterRow = '.filter-row--sticky';
  if ($(stickFilterRow).length !== 0){
    var scrollNow = window.pageYOffset;
    var sticky = $(stickFilterRow).offset().top + $(stickFilterRow).height();

    $(window).scroll(function() {
      scrolled = window.pageYOffset;

      if (window.pageYOffset > sticky && window.pageYOffset > scrollNow) {
        $(stickFilterRow).addClass('active');
        $(stickFilterRow).addClass('container');
      } else {
        $(stickFilterRow).removeClass('active');
        $(stickFilterRow).removeClass('container');
      }
      
      scrollNow = window.pageYOffset;

    });
  }
})();

// Setting data from .com redirection and checking of products' availability based on user's entered location
theme.handleZipInfoOnProductAndHomepage = (function(){
  if (Shopify.queryParams.city && Shopify.queryParams.zip){
    sessionStorage.setItem('localBannerSetDeliveryCity', Shopify.queryParams.city);
    sessionStorage.setItem('localBannerSetDeliveryZipCode', Shopify.queryParams.zip);
    sessionStorage.setItem('localDeliveryLocationTag', Shopify.queryParams.zip);
  }

  if (Shopify.queryParams.loc){
    sessionStorage.setItem('localDeliveryLocationTag', Shopify.queryParams.loc);
  }

  deliveryCity = sessionStorage.getItem('localBannerSetDeliveryCity') || '';
  deliveryZip = sessionStorage.getItem('localBannerSetDeliveryZipCode') || '';
  locationTag = sessionStorage.getItem('localDeliveryLocationTag') || '';
  
  // Functions
  var setTopBannerZip = function(locationTag){
    // function to update zip banner on top of product page
    if(locationTag != ''){
      $('.js-banner-delivery-zip').text(locationTag);

      if(!validateIfZipCode(locationTag) && !validateIfZipValid(locationTag)){
        $('.js-zip-label').addClass('d-none')
      }
    }
  }

  var validateIfNoExtraChar = function(zipEntered){
    // function to check if entered location is alphanumeric
    alphaNumPattern = new RegExp('^[A-Za-z0-9 ()]*$');
    if(alphaNumPattern.test(zipEntered)){
      return true;
    }
    else{
      return false;
    }
  }

  var validateIfZipCode = function(zipEntered){
    // function to check if entered location is zip code or not
    return /\d/.test(zipEntered);
  }

  var validateIfZipValid  = function(zipEntered){
    // function to check if zip code entered is valid or not
    usaZipPattern = new RegExp('(\\d{5})(?:[ \\-](\\d{4}))?');
    caZipPattern = new RegExp('[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d$');
    if (usaZipPattern.test(zipEntered) || caZipPattern.test(zipEntered)){
      return true;
    }
    else {
      return false;
    }
  }
  
  var zipInTags = function(zipEntered, productTagsSelector){
    // function to check if location entered by the user is available in the product tags
    if($(productTagsSelector).length > 0){ 
      allProductTags = ($(productTagsSelector).text()).split(',').map(tag => tag.toLowerCase());
      console.log(allProductTags);
      zipAvailable = $.inArray(zipEntered, allProductTags);

      if(zipAvailable != -1){ return true; } //zip is matched
      else { return false; } //zip not matched
    }
    else {
      return false;
    }
  }

  var productNAModal = function(zipEntered, zipHandle = zipEntered, zipProductName=''){
    //show modal that product is not available to the entered location by the user
    $('#product-zip-entered').text(zipEntered);
    if(zipProductName != ''){
      $('#product-zip-entered-name').text(zipProductName);
    }
    $('#productZipEnteredFailModal').modal('show');
    $(document).on('click', '#productZipEnteredFailModalRedirectButton', function(){
      sessionStorage.setItem('localDeliveryLocationTag', zipEntered);
      location.href = window.location.protocol + '//' + window.location.hostname + '/collections/all/' + zipHandle;
    });
  }

  var zipEnteredHandleized = function(zipEntered){
    // function to generate the handleized version of entered location by the user - specifically for city names
    return (zipEntered.split(" ").map(inputLoc => inputLoc.toLowerCase())).join("-");
  }

  var zipEnteredFormatted = function(zipEntered, zip=true){
    // function to format the entered location for display purposes
    if(zip){
      return (zipEntered.replace(" ", "").toUpperCase());
    }
    else {
      return (zipEntered.split(" ").map(inputLoc => inputLoc.charAt(0).toUpperCase()+inputLoc.slice(1).toLowerCase())).join(" ");
    }
  }

  setTopBannerZip(locationTag);

  // Handling user location information for Product Page
  if($('.div_check-location').length > 0){
    if (locationTag == ''){
      $('.div_check-location').removeClass('product-form-hidden');
    }
    else {
      if(validateIfZipCode(locationTag) && validateIfZipValid(locationTag)){
        // if locationTag is a zip code
        zipAvailable = zipInTags(zipEnteredFormatted(locationTag), '#product_tags');
        if (zipAvailable){
          $('#product-form__quantity-submit').removeClass('product-form-hidden');
          setTopBannerZip(zipEnteredFormatted(locationTag));
        }
        else {
          productNAModal(zipEnteredFormatted(locationTag,zipHandle=zipEnteredFormatted(locationTag)));
        }
      }
      else {
        // if locationTag is a city name
        zipAvailable = zipInTags(zipEnteredFormatted(locationTag, zip=false).toLowerCase(), '#product_tags');
        if (zipAvailable){
          $('#product-form__quantity-submit').removeClass('product-form-hidden');
          setTopBannerZip(zipEnteredFormatted(locationTag, zip=false));
        }
        else {
          productNAModal(zipEnteredFormatted(locationTag, zip=false),zipHandle=zipEnteredHandleized(locationTag));
        }
      }
      
    }

    $('#product_zip-input-field').keypress(function (e) {
      var key = e.which;
      if(key == 13)  // the enter key code
       {
         $('#product_check-zip-btn').click();
         return false;  
       }
     });   

    $(document).on('click','#product_check-zip-btn',function(){
      $userLocation = $('#product_zip-input-field').val();
  
      if($userLocation != '' && validateIfNoExtraChar($userLocation)){
        //Check if the input is a post code (With Numbers)
        $isZipUserLocation = validateIfZipCode($userLocation);

        if($isZipUserLocation){
          //Remove spaces and capitalize the characters of the entered post code
          $userLocationFormatted = zipEnteredFormatted($userLocation);
          $isValidZipCode = validateIfZipValid($userLocationFormatted);

          if($isValidZipCode){
            zipAvailable = zipInTags($userLocationFormatted, '#product_tags');
            if (zipAvailable){
              sessionStorage.setItem('localDeliveryLocationTag', $userLocationFormatted);
              $('#product-form__quantity-submit').removeClass('product-form-hidden');
              $('.div_check-location').addClass('product-form-hidden');
              setTopBannerZip($userLocationFormatted);
            }
            else {
              productNAModal($userLocationFormatted, zipHandle = $userLocationFormatted);
            }
          }
          else {
            //show modal enter zip code or zip code required
            $('#productZipEnteredInvalidModal').modal('show');
          }

        }
        else {
          $userLocationHandleized = zipEnteredHandleized($userLocation);
          $userLocationFormatted = zipEnteredFormatted($userLocation, zip=false);

          zipAvailable = zipInTags($userLocationFormatted.toLowerCase(), '#product_tags');
          if (zipAvailable){
            sessionStorage.setItem('localDeliveryLocationTag', $userLocationFormatted);
            $('#product-form__quantity-submit').removeClass('product-form-hidden');
            $('.div_check-location').addClass('product-form-hidden');
            setTopBannerZip($userLocationFormatted);
          }
          else {
            productNAModal($userLocationFormatted, zipHandle=$userLocationHandleized);
          }

        }
      }
      else {
        //show modal enter zip code or zip code required
          $('#productZipEnteredInvalidModal').modal('show');
      }
    })
  }

  // Handling user location information for Homepage Product List section
  $(document).on('click', '.js-home-product-card', function(){
    $('#home-product_zip-input-field').val('');
    $('#homeProductZipEnteredModal').modal('show');
    var selectedProduct = $(this).attr("id");
    var selectedProductTags = '#' + selectedProduct + ' > #home-product_tags';
    var selectedProductName = $(this).attr("title");
   

    $(document).on('click', '#homeProductZipEnteredModalSubmitButton', function(){
      var $homeZipEntered = $('#home-product_zip-input-field').val();
      console.log(selectedProduct);
      $('#homeProductZipEnteredModal').modal('hide');
  
      if($homeZipEntered != '' && validateIfNoExtraChar($homeZipEntered)){
        //Check if the input is a post code (With Numbers)
        $isZipHomeZipEntered = validateIfZipCode($homeZipEntered);

        if($isZipHomeZipEntered){
          //Remove spaces and capitalize the characters of the entered post code
          $homeZipEnteredFormatted = zipEnteredFormatted($homeZipEntered);
          $isValidZipCode = validateIfZipValid($homeZipEnteredFormatted);

          if($isValidZipCode){
            zipAvailable = zipInTags($homeZipEnteredFormatted, selectedProductTags);
            if (zipAvailable){
              sessionStorage.setItem('localDeliveryLocationTag', $homeZipEnteredFormatted);
              location.href = window.location.protocol + '//' + window.location.hostname + '/collections/all/' + $homeZipEnteredFormatted;
            }
            else {
              productNAModal($homeZipEnteredFormatted, zipHandle = $homeZipEnteredFormatted, zipProductName=selectedProductName);
            }
          }
          else {
            //show modal enter zip code or zip code required
            $('#productZipEnteredInvalidModal').modal('show');
          }

        }
        else {
          $homeZipEnteredHandleized = zipEnteredHandleized($homeZipEntered);
          $homeZipEnteredFormatted = zipEnteredFormatted($homeZipEntered, zip=false);

          zipAvailable = zipInTags($homeZipEnteredFormatted.toLowerCase(), selectedProductTags);
          if (zipAvailable){
            sessionStorage.setItem('localDeliveryLocationTag', $homeZipEnteredFormatted);
            location.href = window.location.protocol + '//' + window.location.hostname + '/collections/all/' + $homeZipEnteredHandleized;
          }
          else {
            productNAModal($homeZipEnteredFormatted, zipHandle=$homeZipEnteredHandleized, zipProductName=selectedProductName);
          }

        }
      }
      else {
        $('#productZipEnteredInvalidModal').modal('show');
      }
    });
  });

  $('#home-product_zip-input-field').keypress(function (e) {
    var key = e.which;
    if(key == 13)  // the enter key code
     {
       $('#homeProductZipEnteredModalSubmitButton').click();
       return false;  
     }
   });
   
})();


// Change Zip Action
theme.headerChangeZipCode = (function(){
  defaultLocationTag = $('.js-banner-delivery-zip').first().text();
  locationTag = sessionStorage.getItem('localDeliveryLocationTag') || defaultLocationTag;

  $('#changeZipEnteredModal #product-zip-entered').text(locationTag);
  $('#changeZipEnteredModal #changeZipEnteredModalShopButton').attr('href', '/collections/all/' + locationTag);
  
  $(document).on('click', '.js-initialize-change-header-delivery', function(){
    $('#changeZipEnteredModal').modal('show');
    $(document).on('click', '#changeZipEnteredModalRedirectButton', function(){
      sessionStorage.setItem('localBannerSetDeliveryCity', '');
      sessionStorage.setItem('localBannerSetDeliveryZipCode', '');
      sessionStorage.setItem('localDeliveryLocationTag', '');

      location.href = 'https://designerblooms.com';
    })
  })
})();


// Cart Attributes - Show only a textarea field if Delivery is to an Apartment/Condo
theme.showCartFieldBuzzerCode = (function(){
  $(document).on('change', 'input[name="attributes[Delivery is to a]"]:checked', function(){
  
  if($('input[name="attributes[Delivery is to a]"]:checked').val() == 'Apartment/Condo'){
    if ($('.js-buzzer-code-field').hasClass('hidden-item')){
      $('.js-buzzer-code-field').removeClass('hidden-item');
    }
  }
  else {
    if (!$('.js-buzzer-code-field').hasClass('hidden-item')){
      $('.js-buzzer-code-field').addClass('hidden-item');
      $('.if-its-an-apartment-or-condo-please-leave-the-buzzer-code').val('');
    }
  }
  })
})();

// Cart Attributes - Show only a textarea field if Delivery is to an Office
theme.showCartFieldOfficeName = (function(){
  $(document).on('change', 'input[name="attributes[Delivery is to a]"]:checked', function(){
  
  if($('input[name="attributes[Delivery is to a]"]:checked').val() == 'Office'){
    if ($('.js-office-name-field').hasClass('hidden-item')){
      $('.js-office-name-field').removeClass('hidden-item');
    }
  }
  else {
    if (!$('.js-office-name-field').hasClass('hidden-item')){
      $('.js-office-name-field').addClass('hidden-item');
      $('.office-or-building-name').val('');
    }
  }
  })
})();

// Cart Attributes - Show only a textarea field if Delivery Options is to Others
theme.showCartFieldOtherCode = (function(){
  $(document).on('change', '#delivery-options', function(){
  
  if($('#delivery-options').val() == 'Other'){
    if ($('.js-other-delivery-options-field').hasClass('hidden-item')){
      $('.js-other-delivery-options-field').removeClass('hidden-item');
    }
  }
  else {
    if (!$('.js-other-delivery-options-field').hasClass('hidden-item')){
      $('.js-other-delivery-options-field').addClass('hidden-item');
      $('#other-delivery-options').val('');
    }
  }
  })
})();

// Cart Attributes - Show only a textarea field if Is this a gift checkbox is checked
theme.showCartFieldGiftMessageCode = (function(){
  $(document).on('change', '#is-this-a-gift', function(){
  
  if($('#is-this-a-gift').is(':checked')){
    if ($('.js-cart-message-field').hasClass('hidden-item')){
      $('.js-cart-message-field').removeClass('hidden-item');
    }
  }
  else {
    if (!$('.js-cart-message-field').hasClass('hidden-item')){
      $('.js-cart-message-field').addClass('hidden-item');
    }
  }
  })
})();

// Make cart fields and the tickbox for accepting Terms & Conditions required
theme.cartFieldsRequired = (function(){
  var $jsDeliveryOptions;
  var $jsDeliveryIsToA;
  var $jsAcceptTC;
  var $jsReasonSending;
  $jsDeliveryOptions = $('#delivery-options').val();
  $jsDeliveryIsToA = $('input[name="attributes[Delivery is to a]"]:checked').val();
  $jsAcceptTC = $('#tc-agree').is(':checked');
  $jsReasonSending = $('input[name="attributes[Reason for Sending]"]:checked').val();
  $jsDeliveryIsToApartmentCondo = $('.if-its-an-apartment-or-condo-please-leave-the-buzzer-code').map(function(){return $(this).val();}).get();
  $jsDeliveryIsToOffice = $('.office-or-building-name').map(function(){return $(this).val();}).get();
  $jsOrderIsGift = $('#is-this-a-gift').is(':checked');
  $jsGiftMessage = $('#gift-message').val();

  $deliveryFormGroup = $('.delivery-form-group');

  // Use ShipZip Shipping/Local Delivery/Store Pickup selection if ShipZip is enabled
  $(window).load(function() {
    if($('#pickup-delivery-option').length > 0){
      $jsPickupDelivery = $('input[name="attributes[Pickup/Delivery]"]:checked').val();
      if(!$jsPickupDelivery && $deliveryFormGroup.hasClass('hidden-item')){
        $("#pd_delivery").prop("checked", true);
        $deliveryFormGroup.removeClass('hidden-item');
      }
    }
    else {
      $jsPickupDelivery = $('#csOrderTypeValue').val();
      if($deliveryFormGroup.hasClass('hidden-item')){
        $("#pd_delivery").prop("checked", true);
        $deliveryFormGroup.removeClass('hidden-item');
      }
      
    }

    // If no pickup/delivery option is chosen yet, default view is display of Delivery fields
    if(($jsPickupDelivery == 'Local Delivery' || $jsPickupDelivery == 'Shipping' || $jsPickupDelivery == 'Delivery') && $deliveryFormGroup.hasClass('hidden-item')){
      $("#pd_delivery").prop("checked", true);
      $deliveryFormGroup.removeClass('hidden-item');
    }

    //Reset clear attributes on page load
    var cartAttribs = {
      'Delivery Options': '',
      'Other Delivery Options': '',
      'Delivery is to a': '',
      'If it’s an Apartment or Condo, please leave the buzzer code: ': '',
      'Reason for Sending': '',
      'Is this a gift?': '',
      'Message': ''
    };
    $('#is-this-a-gift').prop('checked', false);

    $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: {attributes:cartAttribs},
        dataType: 'json'
    });

    // Check additional fields on page load to enable/disable checkout button
    if ($jsPickupDelivery && $jsAcceptTC) {
      if($jsPickupDelivery == 'Pickup' || $jsPickupDelivery == 'Store Pickup'){
        $('.btn-cart-checkout').prop("disabled", false);
      }
      else if(($jsPickupDelivery == 'Delivery' || $jsPickupDelivery == 'Local Delivery' || $jsPickupDelivery == 'Shipping') && $jsDeliveryIsToA && $jsReasonSending){
        if($jsDeliveryIsToA == 'Apartment/Condo'){
          if($jsDeliveryIsToApartmentCondo[0] && $jsDeliveryIsToApartmentCondo[1]){
            $('.btn-cart-checkout').prop("disabled", false);
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }
        }
        else if($jsDeliveryIsToA == 'Office'){
          if($jsDeliveryIsToOffice[0] && $jsDeliveryIsToOffice[1]){
            $('.btn-cart-checkout').prop("disabled", false);
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }
        }
        else {
          $('.btn-cart-checkout').prop("disabled", false);
        }
      }
      else {
        $('.btn-cart-checkout').prop("disabled", true);
      }
    }
    else {
      $('.btn-cart-checkout').prop("disabled", true);
    }


    if($jsDeliveryOptions == 'Other'){
      if ($('.js-other-delivery-options-field').hasClass('hidden-item')){
        $('.js-other-delivery-options-field').removeClass('hidden-item');
      }
    }

    if($jsDeliveryIsToA == 'Apartment/Condo'){
      if ($('.js-buzzer-code-field').hasClass('hidden-item')){
        $('.js-buzzer-code-field').removeClass('hidden-item');
      }
    }

    if($jsDeliveryIsToA == 'Office'){
      if ($('.js-office-name-field').hasClass('hidden-item')){
        $('.js-office-name-field').removeClass('hidden-item');
      }
    }

    if($jsOrderIsGift){
      if ($('.js-cart-message-field').hasClass('hidden-item')){
        $('.js-cart-message-field').removeClass('hidden-item');
      }
    }
    

    // Check if all other required fields are filled out before enabling checkout button - time picker & date picker
    $(document).on('click', '.cs-time-picker, .datepicker--cell', function(){
      $jsPickupDelivery = $('#csOrderTypeValue').val();

      $jsDeliveryOptions = $('#delivery-options').val();
      $jsDeliveryIsToA = $('input[name="attributes[Delivery is to a]"]:checked').val();
      $jsAcceptTC = $('#tc-agree').is(':checked');
      $jsReasonSending = $('input[name="attributes[Reason for Sending]"]:checked').val();
      $jsDeliveryIsToApartmentCondo = $('.if-its-an-apartment-or-condo-please-leave-the-buzzer-code').map(function(){return $(this).val();}).get();
      $jsDeliveryIsToOffice = $('.office-or-building-name').map(function(){return $(this).val();}).get();
            

      $csPickupDateValue = $('#csPickupDateValue').val();
      $csPickupTimeValue = $('#csPickupTimeValue').val();
      $csShippingDateValue = $('#csShippingDateValue').val();
      $csDeliveryDateValue = $('#csDeliveryDateValue').val();

      if($jsPickupDelivery == 'Delivery' || $jsPickupDelivery == 'Local Delivery' || $jsPickupDelivery == 'Shipping'){
        if ($jsDeliveryIsToA && $jsAcceptTC && $jsReasonSending && ($csShippingDateValue || $csDeliveryDateValue)) {
          if($jsDeliveryIsToA == 'Apartment/Condo'){
            if($jsDeliveryIsToApartmentCondo[0] && $jsDeliveryIsToApartmentCondo[1]){
              $('.btn-cart-checkout').prop("disabled", false);
            }
            else {
              $('.btn-cart-checkout').prop("disabled", true);
            }
          }
          else if($jsDeliveryIsToA == 'Office'){
            if($jsDeliveryIsToOffice[0] && $jsDeliveryIsToOffice[1]){
              $('.btn-cart-checkout').prop("disabled", false);
            }
            else {
              $('.btn-cart-checkout').prop("disabled", true);
            }
          }
          else {
            $('.btn-cart-checkout').prop("disabled", false);
          }
        }
        else {
          $('.btn-cart-checkout').prop("disabled", true);
        }
      }
      else if($jsPickupDelivery == 'Pickup' || $jsPickupDelivery == 'Store Pickup'){
        if ($jsAcceptTC && $csPickupTimeValue && $csPickupDateValue) {
          $('.btn-cart-checkout').prop("disabled", false);
        }
        else {
          $('.btn-cart-checkout').prop("disabled", true);
        }
      }
      else {
        $('.btn-cart-checkout').prop("disabled", true);
      }
    })

    // Event listeners if checkout is disabled
    if($('.btn-cart-checkout').is(":disabled")){
      // On change of Pickup/Delivery Field
      $(document).on('change', 'input[name="attributes[Pickup/Delivery]"]', function(){
        $jsPickupDelivery = $('input[name="attributes[Pickup/Delivery]"]:checked').val();

        $jsDeliveryOptions = $('#delivery-options').val();
        $jsDeliveryIsToA = $('input[name="attributes[Delivery is to a]"]:checked').val();
        $jsAcceptTC = $('#tc-agree').is(':checked');
        $jsReasonSending = $('input[name="attributes[Reason for Sending]"]:checked').val();
        $jsDeliveryIsToApartmentCondo = $('.if-its-an-apartment-or-condo-please-leave-the-buzzer-code').map(function(){return $(this).val();}).get();
        $jsDeliveryIsToOffice = $('.office-or-building-name').map(function(){return $(this).val();}).get();
        
        if($jsPickupDelivery == 'Delivery' && $deliveryFormGroup.hasClass('hidden-item')){
          $deliveryFormGroup.removeClass('hidden-item');

          if ($jsDeliveryIsToA && $jsAcceptTC && $jsReasonSending) {
            if($jsDeliveryIsToA == 'Apartment/Condo'){
              if($jsDeliveryIsToApartmentCondo[0] && $jsDeliveryIsToApartmentCondo[1]){
                $('.btn-cart-checkout').prop("disabled", false);
              }
              else {
                $('.btn-cart-checkout').prop("disabled", true);
              }
            }
            else if($jsDeliveryIsToA == 'Office'){
              if($jsDeliveryIsToOffice[0] && $jsDeliveryIsToOffice[1]){
                $('.btn-cart-checkout').prop("disabled", false);
              }
              else {
                $('.btn-cart-checkout').prop("disabled", true);
              }
            }
            else {
              $('.btn-cart-checkout').prop("disabled", false);
            }
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }
          
        }
        else {
          $deliveryFormGroup.addClass('hidden-item');

          if ($jsAcceptTC) {
            $('.btn-cart-checkout').prop("disabled", false);
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }

        }

      });

      // On change of ShipZip Shipping/Local Delivery/Store Pickup
      $(document).on('click', 'ul.cs-tabs li', function(){
        $jsPickupDelivery = $('#csOrderTypeValue').val();

        $jsDeliveryOptions = $('#delivery-options').val();
        $jsDeliveryIsToA = $('input[name="attributes[Delivery is to a]"]:checked').val();
        $jsAcceptTC = $('#tc-agree').is(':checked');
        $jsReasonSending = $('input[name="attributes[Reason for Sending]"]:checked').val();
        $jsDeliveryIsToApartmentCondo = $('.if-its-an-apartment-or-condo-please-leave-the-buzzer-code').map(function(){return $(this).val();}).get();
        $jsDeliveryIsToOffice = $('.office-or-building-name').map(function(){return $(this).val();}).get();
        
        $csPickupDateValue = $('#csPickupDateValue').val();
        $csPickupTimeValue = $('#csPickupTimeValue').val();
        $csShippingDateValue = $('#csShippingDateValue').val();
        $csDeliveryDateValue = $('#csDeliveryDateValue').val();

        if($jsPickupDelivery == 'Local Delivery' || $jsPickupDelivery == 'Shipping'){
          $deliveryFormGroup.removeClass('hidden-item');

          if ($jsDeliveryIsToA && $jsAcceptTC && $jsReasonSending && ($csShippingDateValue || $csDeliveryDateValue)) {
            if($jsDeliveryIsToA == 'Apartment/Condo'){
              if($jsDeliveryIsToApartmentCondo[0] && $jsDeliveryIsToApartmentCondo[1]){
                $('.btn-cart-checkout').prop("disabled", false);
              }
              else {
                $('.btn-cart-checkout').prop("disabled", true);
              }
            }
            else if($jsDeliveryIsToA == 'Office'){
              if($jsDeliveryIsToOffice[0] && $jsDeliveryIsToOffice[1]){
                $('.btn-cart-checkout').prop("disabled", false);
              }
              else {
                $('.btn-cart-checkout').prop("disabled", true);
              }
            }
            else {
              $('.btn-cart-checkout').prop("disabled", false);
            }
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }
          
        }
        else {
          $deliveryFormGroup.addClass('hidden-item');

          if ($jsAcceptTC && $csPickupTimeValue && $csPickupDateValue) {
            $('.btn-cart-checkout').prop("disabled", false);
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }

        }
      })

      // On change of Delivery-related fields
      $(document).on('change', '#delivery-options, input[name="attributes[Delivery is to a]"]:checked, .if-its-an-apartment-or-condo-please-leave-the-buzzer-code, .office-or-building-name, input[name="attributes[Reason for Sending]"]', function(){
        $jsDeliveryOptions = $('#delivery-options').val();
        $jsDeliveryIsToA = $('input[name="attributes[Delivery is to a]"]:checked').val();
        $jsAcceptTC = $('#tc-agree').is(':checked');
        $jsReasonSending = $('input[name="attributes[Reason for Sending]"]:checked').val();
        $jsDeliveryIsToApartmentCondo = $('.if-its-an-apartment-or-condo-please-leave-the-buzzer-code').map(function(){return $(this).val();}).get();
        $jsDeliveryIsToOffice = $('.office-or-building-name').map(function(){return $(this).val();}).get();
        

        if($('#pickup-delivery-option').length > 0){
          $csShippingDateValue = true;
          $csDeliveryDateValue = true;
        }
        else {
          $csShippingDateValue = $('#csShippingDateValue').val();
          $csDeliveryDateValue = $('#csDeliveryDateValue').val();
        }
        
        if ($jsDeliveryIsToA && $jsAcceptTC && $jsReasonSending && ($csShippingDateValue || $csDeliveryDateValue)) {
          if($jsDeliveryIsToA == 'Apartment/Condo'){
            if($jsDeliveryIsToApartmentCondo[0] && $jsDeliveryIsToApartmentCondo[1]){
              $('.btn-cart-checkout').prop("disabled", false);
            }
            else {
              $('.btn-cart-checkout').prop("disabled", true);
            }
          }
          else if($jsDeliveryIsToA == 'Office'){
            if($jsDeliveryIsToOffice[0] && $jsDeliveryIsToOffice[1]){
              $('.btn-cart-checkout').prop("disabled", false);
            }
            else {
              $('.btn-cart-checkout').prop("disabled", true);
            }
          }
          else {
            $('.btn-cart-checkout').prop("disabled", false);
          }
        }
        else {
            $('.btn-cart-checkout').prop("disabled", true);
          }
      });

      // On change of Terms & Conditions checkbox
      $(document).on('change', '#tc-agree', function(){
        // Use ShipZip Shipping/Local Delivery/Store Pickup selection if ShipZip is enabled
        if($('#pickup-delivery-option').length > 0){
          $jsPickupDelivery = $('input[name="attributes[Pickup/Delivery]"]:checked').val();
        }
        else {
          $jsPickupDelivery = $('#csOrderTypeValue').val();
        }

        $jsDeliveryOptions = $('#delivery-options').val();
        $jsDeliveryIsToA = $('input[name="attributes[Delivery is to a]"]:checked').val();
        $jsAcceptTC = $('#tc-agree').is(':checked');
        $jsReasonSending = $('input[name="attributes[Reason for Sending]"]:checked').val();
        $jsDeliveryIsToApartmentCondo = $('.if-its-an-apartment-or-condo-please-leave-the-buzzer-code').map(function(){return $(this).val();}).get();
        $jsDeliveryIsToOffice = $('.office-or-building-name').map(function(){return $(this).val();}).get();
        

        if($('#pickup-delivery-option').length > 0){
          $csPickupDateValue = true;
          $csPickupTimeValue = true;
          $csShippingDateValue = true;
          $csDeliveryDateValue = true;
        }
        else {
          $csPickupDateValue = $('#csPickupDateValue').val();
          $csPickupTimeValue = $('#csPickupTimeValue').val();
          $csShippingDateValue = $('#csShippingDateValue').val();
          $csDeliveryDateValue = $('#csDeliveryDateValue').val();
        }

        if($jsPickupDelivery == 'Delivery' || $jsPickupDelivery == 'Local Delivery' || $jsPickupDelivery == 'Shipping'){
          if ($jsDeliveryIsToA && $jsAcceptTC && $jsReasonSending && ($csShippingDateValue || $csDeliveryDateValue)) {
            if($jsDeliveryIsToA == 'Apartment/Condo'){
              if($jsDeliveryIsToApartmentCondo[0] && $jsDeliveryIsToApartmentCondo[1]){
                $('.btn-cart-checkout').prop("disabled", false);
              }
              else {
                $('.btn-cart-checkout').prop("disabled", true);
              }
            }
            else if($jsDeliveryIsToA == 'Office'){
              if($jsDeliveryIsToOffice[0] && $jsDeliveryIsToOffice[1]){
                $('.btn-cart-checkout').prop("disabled", false);
              }
              else {
                $('.btn-cart-checkout').prop("disabled", true);
              }
            }
            else {
              $('.btn-cart-checkout').prop("disabled", false);
            }
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }
        }
        else if($jsPickupDelivery == 'Pickup' || $jsPickupDelivery == 'Store Pickup'){
          if ($jsAcceptTC && $csPickupTimeValue && $csPickupDateValue) {
            $('.btn-cart-checkout').prop("disabled", false);
          }
          else {
            $('.btn-cart-checkout').prop("disabled", true);
          }
        }
        else {
          $('.btn-cart-checkout').prop("disabled", true);
        }

      });

    }

    
  });


})();

//Lightbox for manual Instagram section on homepage
theme.manualInstagram = (function(){
  $('.instagram-manual').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $('.card-list-carousel').on('init', function(event, slick) {
    var sourceWidth = $('.card-list-carousel .slick-active').width();
    $('#card-list-subscription').width(sourceWidth);
  }).slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $('.instagram-lightbox').slick({
    arrows: true,
    prevArrow: $('.ig-lightbox-prev-arrow'),
    nextArrow: $('.ig-lightbox-next-arrow')
});

  $(document).on('click', '.js-ig-manual-wr', function(){
    var selectedSlideNo = $(this).attr('data-slick-index');

    $('.instagram-lightbox').slick('slickGoTo', selectedSlideNo);
    $('#influencerLightboxModal .modal-content').css('opacity', '0');
    $('#influencerLightboxModal').modal('show');
    setTimeout(() => { 
      $('.instagram-lightbox').slick('refresh'); 
      $('#influencerLightboxModal .modal-content').css('opacity', '1');
    }, 200);
    
  })

  $('.card-list-lightbox').slick({
    arrows: true,
    prevArrow: $('.ig-lightbox-prev-arrow'),
    nextArrow: $('.ig-lightbox-next-arrow')
  });

  $(document).on('click', '.card-list-item', function(){
    var selectedSlideNo = $(this).attr('data-index');
    var sub = $(this).attr('data-sub');
    $('.card-list-lightbox').slick('slickGoTo', selectedSlideNo);
    if(!sub){
      $('#cardLightboxModal').modal('show');
    }else{
      $('#subCardLightboxModal').modal('show');
    }
    
  })

})();

//Stops Instagram Manual Lightbox video from playing on close of modal/lightbox 
theme.manualInstagramVideoStop = (function(){
  $('#influencerLightboxModal').on('hidden.bs.modal', function(){
    $("#influencerLightboxModal video").trigger('pause');
  });

  $('.instagram-lightbox').on('afterChange', function(event, slick, currentSlide){
    $("#influencerLightboxModal video").trigger('pause');
  });
      
})();

// Upselling Offer
theme.upsellingOffer = (function(){
  var $upsellingOfferDivSelector = $('.js-upselling-offer'),
      $upsellingOfferTextSelector = $('.js-upselling-offer-text'),
      $upsellingOfferName = $upsellingOfferDivSelector.data('name') || "cart_total";

  const storeCountry = "US"; // Change if PH, CA, or US store
  var upsellValidArea;
    

  function generate(cart){
    if(storeCountry === "US"){
      const storedDeliveryData = localStorage.getItem("delivery");
      const deliveryInitialData = JSON.parse(storedDeliveryData);

      upsellValidArea = deliveryInitialData && deliveryInitialData.classification == "Local Delivery";
    }
    else {
      upsellValidArea = true;
    }
    
    var minOrderValue = parseInt($upsellingOfferDivSelector.data('value')) || 0;
    var priceCart = cart.total_price;
    var itemsCart = cart.item_count;

    let upsellOfferText = theme.strings.upsellCart;
      
    if(itemsCart > 0 && upsellValidArea){
      $('.js-upselling-offer').show();
      
      if (priceCart < minOrderValue){
        let left = Shopify.formatMoney((minOrderValue - priceCart),theme.moneyFormat);
        upsellOfferText = upsellOfferText.replace('{amount}', left);
        $upsellingOfferTextSelector.html(upsellOfferText);
        $.each($upsellingOfferTextSelector, function(index, element) {
          if ($element.is(':visible')) {
            $upsellingOfferDivSelector.height($upsellingOfferTextSelector.outerHeight() + 40);
          } 
        });
        theme.updateCurrencies();
      }
      else {
        $('.js-upselling-offer').hide();
      }
    }
    else {
      $('.js-upselling-offer').hide();
    }
      
  }

  function productInCart(cart){
    if(storeCountry === "US"){
      const storedDeliveryData = localStorage.getItem("delivery");
      const deliveryInitialData = JSON.parse(storedDeliveryData);

      upsellValidArea = deliveryInitialData && deliveryInitialData.classification == "Local Delivery";
    }
    else {
      upsellValidArea = true;
    }
    
    const productJson = $('#ProductJson-product-template-dbandco');
    
    var upsellOfferText = theme.strings.upsellUpsize;
    var variantsUpsellEligible = $upsellingOfferDivSelector.data('sizes') || '';
    var variantsUpsellEligibleArray = variantsUpsellEligible.split(',').map(variant => variant.trim().toLowerCase());
    var itemsCart = cart.item_count;
    let productsToUpsell = [];

    if(itemsCart > 0 && upsellValidArea){
      $.each(cart.items, function(index, cartItem) {
        if(
          variantsUpsellEligibleArray.includes(cartItem.variant_title.toLowerCase()) && 
          cartItem.title.toLowerCase().includes('bouquet') 
        ){
          productsToUpsell.push(cartItem.product_id);
        }
      });

      if(productsToUpsell.length > 0){
        $('.js-upselling-offer').show();
        $upsellingOfferTextSelector.html(upsellOfferText);
        $.each($upsellingOfferTextSelector, function(index, element) {
          if ($element.is(':visible')) {
            $upsellingOfferDivSelector.height($upsellingOfferTextSelector.outerHeight() + 40);
          } 
        });
      }else{
        $('.js-upselling-offer').hide();
      }

      if(productJson.length > 0){
        const productJsonData = JSON.parse(productJson.html());
        if(!productsToUpsell.includes(productJsonData.id)){
          $('.js-upselling-locate-product').hide();
        }
      }
      
    }
    else {
      $('.js-upselling-offer').hide();
    }
  }

  function showPromoCode(cart){
    var itemsCart = cart.item_count;

    let upsellOfferText = theme.strings.upsellCode;
      
    if(itemsCart > 0){
      $('.js-upselling-offer').show();
      $upsellingOfferTextSelector.html(upsellOfferText);

      $.each($upsellingOfferTextSelector, function(index, element) {
        if ($element.is(':visible')) {
          $upsellingOfferDivSelector.height($upsellingOfferTextSelector.outerHeight() + 40);
        } 
      });
      
    }
    else {
      $('.js-upselling-offer').hide();
    }
      
  }

  function showCollectionPromoCode(cart){
    var itemsCart = cart.item_count;

    let upsellOfferText;
    let upsellCollectionProducts = theme.strings.upsellColl;
    let productInCollection = false;
      
    if(itemsCart > 0){
      $.each(cart.items, function(index, cartItem) {
       if(upsellCollectionProducts.includes(cartItem.product_id)){
         productInCollection = true;
       }
      });

      if(productInCollection){
        upsellOfferText = theme.strings.upsellCollCode;
      }
      else {
        upsellOfferText = theme.strings.upsellCode;
      }
      
      $('.js-upselling-offer').show();
      $upsellingOfferTextSelector.html(upsellOfferText);

      $.each($upsellingOfferTextSelector, function(index, element) {
        if ($element.is(':visible')) {
          $upsellingOfferDivSelector.height($upsellingOfferTextSelector.outerHeight() + 40);
        } 
      });
    }
    else {
      $('.js-upselling-offer').hide();
    }
  }

  if($upsellingOfferName == 'product_upsize'){
    Shopify.getCart(function(cart){
      productInCart(cart);
    });
    return {
      load: productInCart
    }
  }
  else if($upsellingOfferName == 'use_code'){
    Shopify.getCart(function(cart){
      showPromoCode(cart);
    });
    return {
      load: showPromoCode
    }
  }
  else if($upsellingOfferName == 'use_collection_code'){
    Shopify.getCart(function(cart){
      showCollectionPromoCode(cart);
    });
    return {
      load: showCollectionPromoCode
    }
  }
  else {
    Shopify.getCart(function(cart){
      generate(cart);
    });
    return {
      load:generate
    }
  }

})();


//Notice on change of initial delivery/shipping details
theme.upsellingOfferNotice = (function(){
  const productContainer = $('[data-section-type="product"]');
  const productSectionId = productContainer.attr('data-section-id');
  
  const stateInput = $('#delivery-date-state-input');
  const zipInput = $('#delivery-date-zip-input');
  const deliveryDateInput = $('#delivery-date-input');

  function getProductVendor(){
    const productJson = $('#ProductJson-' + productSectionId);
    const productJsonData = JSON.parse(productJson.html());
    return productJsonData.vendor;
  }

  function populateDeliveryDetails(){
    const storedDeliveryData = localStorage.getItem("delivery");
    const deliveryInitialData = JSON.parse(storedDeliveryData);
    const caStateNote = $('#ca-state-note');
    const unavailableDateNote = $('#date-note');

    Shopify.getCart(function(cart){
      if (cart.item_count > 0 && deliveryInitialData){
        caStateNote.hide();
        unavailableDateNote.hide();
        
        stateInput.val(deliveryInitialData.state);
        document.getElementById('state_suggestions').innerHTML='';
        stateInput.show();

        if(stateInput.closest('.input-box').is(":hidden") && deliveryInitialData.classification == "Shipping"){
          $('#AddToCart-' + productSectionId).prop('disabled', true);
        }
        else {
          $('#AddToCart-' + productSectionId).prop('disabled', false);
        }

        if(deliveryInitialData.zip != ''){
          zipInput.val(deliveryInitialData.zip);
          zipInput.show();
        }
        else {
          zipInput.val(deliveryInitialData.zip);
          caStateNote.hide();
          if(!stateInput.closest('.input-box').is(":hidden")){
            zipInput.hide();
          }
        }

        let deliveryCalendarData = theme.customDeliveryConditions.determineDeliveryCalendarDetails(deliveryInitialData.classification);
        let productFloristsOnCart = [];
        $.each(cart.items, function(index, cartItem) {
         if(productFloristsOnCart.indexOf(cartItem.vendor) === -1){
           productFloristsOnCart.push(cartItem.vendor);
         }
        });
        
        let preSelectedDate = theme.cartCustomDeliveryDateSelection.updateReturnSelectedDate(deliveryCalendarData, deliveryInitialData, false);       
        if(!productFloristsOnCart.includes(getProductVendor()) && deliveryInitialData.date != preSelectedDate.toFormat('MM/dd/yyyy')){
          deliveryDateInput.css("color", "red");
          $('#AddToCart-' + productSectionId).prop('disabled', true);
          unavailableDateNote.show();
        }
        else {
          //Check if pre-selected delivery date is still available. Otherwise, adjust to the earliest possible date
          theme.cartCustomDeliveryDateSelection.updateReturnSelectedDate(deliveryCalendarData, deliveryInitialData);
          unavailableDateNote.hide();
        }
        
        deliveryDateInput.val(deliveryInitialData.date);
        deliveryDateInput.prop('disabled', false);

        theme.customDeliveryConditions.showDeliveryCalendar(deliveryCalendarData);

      }

    });
  }

  function checkCartItemsDeliveryChange(inputFieldToChange){
    const storedDeliveryData = localStorage.getItem("delivery");
    const deliveryInitialData = JSON.parse(storedDeliveryData);

    Shopify.getCart(function(cart){
        if (cart.item_count > 0 && deliveryInitialData){

          if(inputFieldToChange === "state"){          
            if(deliveryInitialData.state != stateInput.val()){
              console.log("PROMPT: KEEP STATE OR NEW STATE");
              $('#upsellingNoticeModal')
                .find('.modal-body .current-input-change, .modal-footer .btn-new-del-data, .modal-footer .btn-keep-del-data')
                .text('state');
              $('#upsellingNoticeModal').modal('show');
            }else{
              populateDeliveryDetails();
            }
          }
  
          if(inputFieldToChange === "zip"){              
            if(deliveryInitialData.zip != zipInput.val()){
              console.log("PROMPT: KEEP ZIP CODE OR NEW ZIP CODE");
              $('#upsellingNoticeModal')
                .find('.modal-body .current-input-change, .modal-footer .btn-new-del-data, .modal-footer .btn-keep-del-data')
                .text('zip code');
              $('#upsellingNoticeModal').modal('show');
            }else{
              populateDeliveryDetails();
            }
          }
  
          if(inputFieldToChange === "date"){
            if(deliveryInitialData.date != deliveryDateInput.val()){
              console.log("PROMPT: KEEP DELIVERY DATE OR NEW DELIVERY DATE");
              $('#upsellingNoticeModal')
                .find('.modal-body .current-input-change, .modal-footer .btn-new-del-data, .modal-footer .btn-keep-del-data')
                .text('delivery date');
              $('#upsellingNoticeModal').modal('show');
            }else{
              populateDeliveryDetails();
            }
          }
          
        }
      });
  }

  $('#js-clear-cart-btn').on('click', function(){
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() {
        $('#upsellingNoticeModal').modal('hide');
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log('Error occurred', textStatus);
      }
    });
    return false;
  });

  $('#js-close-upselling-notice-btn').on('click', function () {
    $('#upsellingNoticeModal').modal('hide');
    populateDeliveryDetails();
  });

  document.addEventListener('resultFetched', function () {
      populateDeliveryDetails();
  });
  
  return {
    checkCart: checkCartItemsDeliveryChange,
    prefill: function(){
      const productJson = $('#ProductJson-' + productSectionId);
      if(productJson.length > 0){
        populateDeliveryDetails();
      }
    }
  }
})();


// Additional Fields on Product Page
// Enable or Disable Adding to Cart based on Customer Location
theme.customDeliveryConditions = (function(){
  const productContainer = $('[data-section-type="product"]');
  const productSectionId = productContainer.attr('data-section-id');
  
  const productJson = $('#ProductJson-' + productSectionId);
  const productTemplateAddToCartButton = $('#AddToCart-' + productSectionId);
  const productTemplateAddToCartForm = $('#AddToCartForm-' + productSectionId);

  const stateInput = $('#delivery-date-state-input');
  const stateSuggestionsList = document.getElementById('state_suggestions');
  const zipInput = $('#delivery-date-zip-input');
  const deliveryDateInput = $('#delivery-date-input');

  const productVariantsNotForShipping = "Luxe, Prestige";
  
  const usStatesList = [
      "Alabama", "Alaska", "Arizona", "Arkansas", "California",
      "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
      "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
      "Maine", "Maryland", "Massachusetts", "Michigan",
      "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
      "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina",
      "North Dakota", "Ohio", "Oklahoma", "Oregon",
      "Pennsylvania", "Rhode Island", "South Carolina",
      "South Dakota", "Tennessee", "Texas", "Utah",
      "Vermont", "Virginia", "Washington", "Washington DC", "West Virginia", "Wisconsin", "Wyoming"
    ];

  const sfbaVendors = ["Park"];
  const sfbaSelectVendors = ["Everyday Flowers & Balloons", "Flower Bowl"];
  const laVendors = ["Noble Garden Florist", "The Flowers", "Orchid Republic Floral Boutique", "The Scarlet Flower", "Viola", "Coral Path Designs"];
  const ocVendors = ["Here Come The Blooms", "Studio C Florals"];

  function getProductTags(){
    const productJsonData = JSON.parse(productJson.html());
    return productJsonData.tags.map(tag => tag.trim().toLowerCase());
  }

  function getProductVendor(){
    const productJsonData = JSON.parse(productJson.html());
    return productJsonData.vendor;
  }
  
  function hasShippingTag(){
    const productTags = getProductTags();
    return productTags.includes('shipping');
  }

  function isProductSizeForShipping(){
    var productSizeOption = $('input[name="size"].single-option-selector-' + productSectionId + ':checked');
    var productBoxSizeOption = $('input[name="box-size"].single-option-selector-' + productSectionId + ':checked');
    var productSizeOptionSelected =  productSizeOption.length > 0 ? productSizeOption.val() : productBoxSizeOption.val();
    var productVariantsNotForShippingArray = productVariantsNotForShipping.split(',').map(variant => variant.trim().toLowerCase());
    return !productVariantsNotForShippingArray.some(element => productSizeOptionSelected.toLowerCase().startsWith(element));    
  }

  function isWithinCutoffTime(cutoffTimeSet){
    let currentDate = dateTimeInPstTimezone;
    let cutoffTime = dateTimeInPstTimezone.set(cutoffTimeSet);
    if(currentDate >= cutoffTime){
      return false;
    }
    else {
      return true;
    }
  }

      
  function isInTheZipCodeList(zipCodes, zipValue) {
    return zipCodes.includes(zipValue);
  }
  
  function isValidCaliforniaZipCode(input) {
    const californiaZipCodePattern = new RegExp('^(90\\d{3}|9[1-5]\\d{3})$');
    return californiaZipCodePattern.test(input);
  }

  function showRequiredDeliveryInputs(){
    const handDeliveryOnlyNote = $('#hand-delivery-only-note');
    const stateNote = $('#state-note');
    const caStateNote = $('#ca-state-note');
    const sizeNotForShippingNote = $('#size-not-for-shipping-note');

    stateNote.hide();
    caStateNote.hide();
    sizeNotForShippingNote.hide();
    
    stateInput.prop('disabled', false);
    zipInput.val('');
    deliveryDateInput.val('');
    
    if(!hasShippingTag() || !isProductSizeForShipping()){
      stateInput.closest('.input-box').hide();
      stateInput.val('California');
      zipInput.closest('.input-box').find('label').show();
      zipInput.show();
      handDeliveryOnlyNote.show();

      $('#delivery-date-details-box').addClass('align-items-end');

      const productVendor = getProductVendor();
      if(sfbaVendors.includes(productVendor)){
        $('.delivery-vendor-area').html('to select areas within the San Francisco Bay Area');
        $('.delivery-vendor-zip').html('a San Francisco');
      }
      else if(sfbaSelectVendors.includes(productVendor)){
        $('.delivery-vendor-area').html('to select areas within the San Francisco Bay Area');
        $('.delivery-vendor-zip').html('a San Francisco');
      }
      else if(laVendors.includes(productVendor)){
        $('.delivery-vendor-area').html('to select areas within LA County');
        $('.delivery-vendor-zip').html('a Los Angeles');
      }
      else if(ocVendors.includes(productVendor)){
        $('.delivery-vendor-area').html('to select areas within Orange County');
        $('.delivery-vendor-zip').html('an Orange County');
      }
      else{
        $('.delivery-vendor-area').html('to select areas within the San Francisco Bay Area');
        $('.delivery-vendor-zip').html('a San Francisco');
      }
      
    }
    else{
      stateInput.closest('.input-box').show();
      stateSuggestionsList.innerHTML = '';
      stateInput.val('');
      zipInput.closest('.input-box').find('label').hide();
      zipInput.hide();
      handDeliveryOnlyNote.hide();

      $('#delivery-date-details-box').removeClass('align-items-end');
    }
  }

  function checkDeliveryInputs(){
    const stateNote = $('#state-note');
    const caStateNote = $('#ca-state-note');
    
    // Show US states dropdown on state input focus
    stateInput.on('input', function(){
      const stateValue = stateInput.val().trim().toLowerCase();
      stateSuggestionsList.innerHTML = '';
      deliveryDateInput.val('');
      deliveryDateInput.prop('disabled', true);
      zipInput.hide();
      caStateNote.hide();
      zipInput.val('');
  
      if (stateValue.length > 0) {
        const filteredStates = usStatesList.filter(state => state.toLowerCase().startsWith(stateValue));
        suggestions = filteredStates;
        suggestions.forEach(state => {
          const li = document.createElement('li');
          li.textContent = state;
          stateSuggestionsList.appendChild(li);
        });
      }
  
    });
  
  
    // Check if state entered is a valid state
    stateInput.on('blur', function(){
      const stateValue = stateInput.val().trim().toLowerCase();
      if(stateValue == '' || !usStatesList.includes(stateInput.val())){
        stateNote.show();
      }else{
        stateNote.hide();
        theme.upsellingOfferNotice.checkCart("state"); //added code for upselling verification
      }
    });
  
    // Enable or Disable other inputs based on state selected
    stateSuggestionsList.addEventListener('click', (event) => {
      if (event.target.tagName === 'LI') {
        const selectedState = event.target.textContent;
        const stateValue = selectedState.trim().toLowerCase();
        
        stateInput.val(selectedState);
        stateSuggestionsList.innerHTML = '';
        stateNote.hide();
        
        if (stateValue === 'california') {
          zipInput.show();
          zipInput.focus();
          theme.upsellingOfferNotice.checkCart("state"); //added code for upselling verification            
        }
        else {
          zipInput.hide();
          zipInput.val('');
          
          theme.upsellingOfferNotice.checkCart("state"); //added code for upselling verification
                
          if (stateValue != '') {
            showDeliveryCalendar(determineDeliveryCalendarDetails("Shipping"));
          }
        }
      }
    });
  
    // Check if the zip entered is a valid California zip
    zipInput.on('blur', function () {
      const zipValue = zipInput.val().trim().toLowerCase();
      if(!isValidCaliforniaZipCode(zipValue)){
        caStateNote.show();
      }else {
        caStateNote.hide();
        theme.upsellingOfferNotice.checkCart("zip"); //added code for upselling verification
      }
    });
  
    // Enable or Disable other inputs based on zip entered
    zipInput.on('input', function () {
      const zipValue = zipInput.val().trim().toLowerCase();
      const sizeNotForShippingNote = $('#size-not-for-shipping-note');
      
      deliveryDateInput.val('');
  
      const zipCodes = getProductTags();
      
      if(isValidCaliforniaZipCode(zipValue)){
        if(!isInTheZipCodeList(zipCodes, zipValue)){
          if (hasShippingTag()){
            if(isProductSizeForShipping()){
              showDeliveryCalendar(determineDeliveryCalendarDetails("Shipping"));
              sizeNotForShippingNote.hide();
            }
            else{
              sizeNotForShippingNote.show();
            }
          }else {
            showRedirectModal(zipValue);
          }
        }else{
          showDeliveryCalendar(determineDeliveryCalendarDetails("Local Delivery"));
        }
      }
      else{
        sizeNotForShippingNote.hide();
        deliveryDateInput.prop('disabled', true);
        productTemplateAddToCartButton.prop('disabled', true);
      }
    });

    // Show the required delivery inputs for the selected product size
    // const productSizeOptions = document.querySelectorAll('input[name="size"].single-option-selector-' + productSectionId);
    var productSizesOptions = document.querySelectorAll('input[name="size"].single-option-selector-' + productSectionId);
    var productBoxSizesOptions = document.querySelectorAll('input[name="box-size"].single-option-selector-' + productSectionId);
    var productSizeOptions =  productSizesOptions.length > 0 ? productSizesOptions : productBoxSizesOptions;
    
    productSizeOptions.forEach((sizeSelector) => {
      sizeSelector.addEventListener('click', function(event){
        theme.upsellingOfferNotice.prefill();
        showRequiredDeliveryInputs();
      });
    });
  }
    
  function showRedirectModal(zipInputValue){
    // $('#localProductNoticeModal .btn-redirect').attr('href', '/collections/all/' + zipInputValue);
    $('#localProductNoticeModal').modal('show');
  }

  function returnFloristCalendarDetails(defaultDeliveryCalendarData){
    const cartContainer = $('[data-section-type="cart"]');
    const cartSectionId = cartContainer.attr('data-section-id');
    const cartJson = $('#CartJson-' + cartSectionId);
    const cartJson1 = $('#CartJson1-' + productSectionId);
        
    const floristsList = [
      {
        name: "Flower Bowl",
        disabledDays: [0, 1],
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      {
        name: "Everyday Flowers & Balloons",
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      { 
        name: "Noble Garden Florist",
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      {
        name: "The Flowers",
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      { 
        name: "Orchid Republic Floral Boutique",
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      {
        name: "The Scarlet Flower",
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      { 
        name: "Viola",
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      {
        name: "Coral Path Designs",
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      { 
        name: "Here Come The Blooms",
        disabledDays: [0, 1],
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      },
      {
        name: "Studio C Florals",
        disabledDays: [0, 6],
        fridayNextDayCutoffTime: {hour: 13, minute: 0, second: 0, millisecond: 0}
      }
    ];

    function findFloristByName(name, floristsList){
      for (var i=0; i < floristsList.length; i++) {
        if (floristsList[i].name === name) {
          return floristsList[i];
        }
      }
      return null;
    }

    function compareAllFloristsCalendarData(allProductFloristsOnCart){
      disabledDays = allProductFloristsOnCart[0].disabledDays ? allProductFloristsOnCart[0].disabledDays : defaultDeliveryCalendarData.disabledDays;
      sameDayCutoffTime = allProductFloristsOnCart[0].sameDayCutoffTime ? allProductFloristsOnCart[0].sameDayCutoffTime : defaultDeliveryCalendarData.sameDayCutoffTime;
      fridayNextDayCutoffTime = allProductFloristsOnCart[0].fridayNextDayCutoffTime ? allProductFloristsOnCart[0].fridayNextDayCutoffTime : defaultDeliveryCalendarData.fridayNextDayCutoffTime;
      
      for (var i=1; i < allProductFloristsOnCart.length; i++) {
        if(allProductFloristsOnCart[i].sameDayCutoffTime){
          if (allProductFloristsOnCart[i].sameDayCutoffTime.hour < sameDayCutoffTime.hour) {
            sameDayCutoffTime = allProductFloristsOnCart[i].sameDayCutoffTime;
          }
        }

        if (allProductFloristsOnCart[i].fridayNextDayCutoffTime){
          if (allProductFloristsOnCart[i].fridayNextDayCutoffTime.hour < fridayNextDayCutoffTime.hour) {
            fridayNextDayCutoffTime = allProductFloristsOnCart[i].fridayNextDayCutoffTime;
          }
        }

        if(allProductFloristsOnCart[i].disabledDays){
          for (var j = 0; j < allProductFloristsOnCart[i].disabledDays.length; j++) {
            if (!disabledDays.includes(allProductFloristsOnCart[i].disabledDays[j])) {
              disabledDays.push(allProductFloristsOnCart[i].disabledDays[j]);
            }
          }
        }

        return {
          disabledDays: disabledDays,
          fridayNextDayCutoffTime: fridayNextDayCutoffTime,
          sameDayCutoffTime: sameDayCutoffTime
        };
        
      }
    }
    
    if(cartJson.length > 0){
      const cartJsonData = JSON.parse(cartJson.html());
      if(cartJsonData.item_count > 0){
        let productFloristsOnCart = [];
        $.each(cartJsonData.items, function(index, cartItem) {
         if(productFloristsOnCart.indexOf(cartItem.vendor) === -1){
           productFloristsOnCart.push(cartItem.vendor);
         }
        });

        if(productFloristsOnCart.length === 1){
          let cartProductFlorist = findFloristByName(productFloristsOnCart[0], floristsList) || defaultDeliveryCalendarData;
          return {
            disabledDays: cartProductFlorist.disabledDays ? cartProductFlorist.disabledDays : defaultDeliveryCalendarData.disabledDays,
            fridayNextDayCutoffTime: cartProductFlorist.fridayNextDayCutoffTime ? cartProductFlorist.fridayNextDayCutoffTime : defaultDeliveryCalendarData.fridayNextDayCutoffTime,
            sameDayCutoffTime: cartProductFlorist.sameDayCutoffTime ? cartProductFlorist.sameDayCutoffTime : defaultDeliveryCalendarData.sameDayCutoffTime
          };

        }
        else {
          let allProductFloristsOnCart = [];
          $.each(productFloristsOnCart, function(index, floristCart){
            let floristOnCart = findFloristByName(floristCart, floristsList) || defaultDeliveryCalendarData;
            allProductFloristsOnCart.push(floristOnCart);
          })
          return compareAllFloristsCalendarData(allProductFloristsOnCart);
        }
        
      }   
    }

    if(productJson.length > 0){
      let productFlorist = findFloristByName(getProductVendor(), floristsList) || defaultDeliveryCalendarData;
      const cartJsonData1 = JSON.parse(cartJson1.html());

      if(cartJsonData1.item_count > 0){
        let productFloristsOnCart = [];
        $.each(cartJsonData1.items, function(index, cartItem) {
         if(productFloristsOnCart.indexOf(cartItem.vendor) === -1){
           productFloristsOnCart.push(cartItem.vendor);
         }
        });      

        let allProductFloristsOnCart = [];
        $.each(productFloristsOnCart, function(index, floristCart){
          let floristOnCart = findFloristByName(floristCart, floristsList) || defaultDeliveryCalendarData;
          allProductFloristsOnCart.push(floristOnCart);
        })
        allProductFloristsOnCart.push(productFlorist);
        return compareAllFloristsCalendarData(allProductFloristsOnCart);
      }
      else {
        return {
          disabledDays: productFlorist.disabledDays ? productFlorist.disabledDays : defaultDeliveryCalendarData.disabledDays,
          fridayNextDayCutoffTime: productFlorist.fridayNextDayCutoffTime ? productFlorist.fridayNextDayCutoffTime : defaultDeliveryCalendarData.fridayNextDayCutoffTime,
          sameDayCutoffTime: productFlorist.sameDayCutoffTime ? productFlorist.sameDayCutoffTime : defaultDeliveryCalendarData.sameDayCutoffTime
        };
      }

    }
    
    return defaultDeliveryCalendarData;

  }  
  
  function determineDeliveryCalendarDetails(deliveryClassification){
    let addToDate;
    let disabledDays;
    let disabledDatesRange;

    let currentDate = dateTimeInPstTimezone;
        
    if(deliveryClassification == "Local Delivery"){
      // Define disabled delivery dates
      const defaultDeliveryCalendarData = {
        disabledDays : [0], //Sunday
        // disabledDatesRange : {from: "2023-11-13", to: "2023-11-17"},
        sameDayCutoffTime : { hour: 8, minute: 0, second: 0, millisecond: 0 }, // Define cutoff time for same day delivery in json (24-hr format)
        fridayNextDayCutoffTime : { hour: 16, minute: 0, second: 0, millisecond: 0 } // Define cutoff time on Fridays for Saturday delivery in json (24-hr format)
      }

      let newCalendarData = returnFloristCalendarDetails(defaultDeliveryCalendarData);
      disabledDays = newCalendarData.disabledDays;
      sameDayCutoffTime = newCalendarData.sameDayCutoffTime;
      fridayNextDayCutoffTime = newCalendarData.fridayNextDayCutoffTime;
      
      // Check if order is eligible for same day or Saturday delivery
      let isValidSameDay = isWithinCutoffTime(sameDayCutoffTime);
      let isValidSatDelivery = isWithinCutoffTime(fridayNextDayCutoffTime);
      let isValidFridayDelivery = isWithinCutoffTime({ hour: 18, minute: 0, second: 0, millisecond: 0 }); //added for Friday delivery cutoff

      addToDate = 0;

      if(!isValidSameDay){addToDate = 1;}
      if(currentDate.weekday == 4 && !isValidFridayDelivery){addToDate = 2;} //added for Friday delivery cutoff
      if(currentDate.weekday == 5 && !isValidSatDelivery){addToDate = 2;}
      if(currentDate.weekday == 6){addToDate = 1;}
      
    }
    else {
      // SHIPPING 
      
      // Define disabled delivery dates
      disabledDays = [0, 1]; //Sunday, Monday
      // disabledDatesRange = {from: "2023-11-13", to: "2023-11-17"};

      // Define cutoff time for 2-day lead time shipping in json (24-hr format)
      let twoDaysCutoffTime = { hour: 11, minute: 0, second: 0, millisecond: 0 };

      // Define cutoff time on Saturdays for Tuesday shipping in json (24-hr format)
      let saturdayCutoffTime = { hour: 8, minute: 0, second: 0, millisecond: 0 };
      
      // Check if order is eligible for 2-days or Saturday shipout
      let isValidTwoDays = isWithinCutoffTime(twoDaysCutoffTime);
      let isValidSatShipOut = isWithinCutoffTime(saturdayCutoffTime);

      addToDate = 2;

      if(!isValidTwoDays){addToDate = 3;}      
      if(currentDate.weekday == 6 && !isValidSatShipOut){addToDate = 4;}
      
    }

    const deliveryCalendarData = {
      addToDate: addToDate,
      disabledDays: disabledDays,
      disabledDatesRange: disabledDatesRange,
      deliveryClassification: deliveryClassification
    };

    localStorage.setItem("deliveryClassification", deliveryClassification);

    return deliveryCalendarData;
  }

  function showDeliveryCalendar(deliveryCalendarData){
    let addToDate = deliveryCalendarData.addToDate;
    let disabledDays = deliveryCalendarData.disabledDays;
    let disabledDatesRange = deliveryCalendarData.disabledDatesRange;
    let deliveryClassification = deliveryCalendarData.deliveryClassification;
        
    let minDate = dateTimeInPstTimezone;
    minDate = minDate.set({ day:(minDate.day + addToDate)});
    minDate = minDate.toFormat('yyyy-MM-dd');
        
    const flatpickr_conf = {
      minDate: minDate,
      disable: [
        function(date) {
          return disabledDays.includes(date.getDay());
        },
        disabledDatesRange,
        ...disabledDeliveryDates.map((date) => date),
      ],
    }
    initializeFlatpickr(flatpickr_conf);
    deliveryDateInput.prop('disabled', false);
  }

  function productAddedToCart(){
    productTemplateAddToCartForm.on('submit', function(){
      let deliveryDate = luxon.DateTime.fromFormat(deliveryDateInput.val(), 'MM/dd/yyyy', { zone: pstTimezone });
      let deliveryDay = deliveryDate.toFormat('cccc');

      const data = {
        state: stateInput.val(),
        zip: zipInput.val(),
        date: deliveryDateInput.val(),
        classification: localStorage.getItem("deliveryClassification"),
        day: deliveryDay
      };
      
      const jsonData = JSON.stringify(data);
      localStorage.setItem("delivery", jsonData);
          
    })
  }

  function initializeFlatpickr(config) {
    let flatpickrInstance;
    const deliveryDatePicker = $('#delivery-date-input');
    
    if (flatpickrInstance) {
      flatpickrInstance.destroy();
    }
  
    flatpickrInstance = deliveryDatePicker.flatpickr({
      ...config,
      dateFormat: "m/d/Y",
      onChange: function(selectedDates, dateStr, instance) {
        if($('#date-note').is(':hidden')){
          theme.upsellingOfferNotice.checkCart("date"); //added code for upselling verification
        }
        else {
          $('#date-note').hide();
          deliveryDateInput.css("color", "");
        }
        
        if (dateStr.trim() !== '') {
          productTemplateAddToCartButton.prop('disabled', false);
        } else {
          productTemplateAddToCartButton.prop('disabled', true);
        }
      }
    });
                                                              
  }
  

  // Run this function when in product page
  if(productJson.length > 0){
    console.log("Shipping Conditions Running...");
    showRequiredDeliveryInputs();
    checkDeliveryInputs();
    productAddedToCart();
  }

  return {
    showDeliveryCalendar: showDeliveryCalendar,
    determineDeliveryCalendarDetails: determineDeliveryCalendarDetails,
    showRequiredDeliveryInputs: function(){
      if(productJson.length > 0){
        showRequiredDeliveryInputs();
      }
    }
  }


})();

theme.cartCustomDeliveryDateSelection = (function(){
  const cartForm = $('form.cart');
  $(document).ready(function(){
    $(document).on('click', '#sbzBox', function(e){
      const firstLi = $(e.target).closest('.cs-tabs.cs-crawler-tabs li[rel="cs-tab1"]');
      if (firstLi.length > 0) {
        const radioElement = $('#sbzBox').find('.cs-tabs.cs-crawler-tabs li:first-child');
        const storedDeliveryData = localStorage.getItem("delivery");
        const deliveryData = JSON.parse(storedDeliveryData);
      
        if(deliveryData){
          if(deliveryData.classification == 'Local Delivery'){
            radioElement.html(`
                              <svg fill="#000000" width="30px" height="30px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                <g data-name="16 Local Delivery box" id="_16_hand_delivery_box">
                                  <path d="M60.27,42.62l-.43-1.19a3.851,3.851,0,0,0-4.2-2.42c-.05.01-.09.01-.14.02V13.5c0-.01-.01-.02-.01-.04a.8.8,0,0,0-.06-.3.637.637,0,0,0-.02-.07c-.01-.01-.01-.03-.02-.04l-3-6a.988.988,0,0,0-.89-.55h-27a1,1,0,0,0-.83.45l-4,6a.388.388,0,0,0-.06.11c-.01.03-.03.05-.04.08a1.372,1.372,0,0,0-.07.34V32.92c-.15.02-.3.04-.45.07l-4.08.92V30.5a2.006,2.006,0,0,0-2-2H5.5a2.006,2.006,0,0,0-2,2v25a2.006,2.006,0,0,0,2,2h7.47a2.006,2.006,0,0,0,2-2V52.89L31.5,55.88a12.715,12.715,0,0,0,7-.69l19.52-7.73A3.8,3.8,0,0,0,60.27,42.62ZM12.97,55.5H5.5v-25h7.47ZM42.5,8.5h8.38l2,4H42.5Zm-8,0h6v4h-6Zm0,6h6v12l-2.4-1.8a1,1,0,0,0-1.2,0l-2.4,1.8Zm-9.46-6H32.5v4H22.37Zm-3.54,6h11v14a.977.977,0,0,0,.55.89,1,1,0,0,0,1.05-.09l3.4-2.55,3.4,2.55a1.029,1.029,0,0,0,.6.2.908.908,0,0,0,.45-.11.977.977,0,0,0,.55-.89v-14h11V39.28c-.5.07-1.01.15-1.5.24-1.01.16-2.06.34-3.08.44a53.558,53.558,0,0,1-7.03.33,53.365,53.365,0,0,1-5.91-.52,3.661,3.661,0,0,0-.33-2.03,4,4,0,0,0-2.54-2.08l-9.48-2.57a9.536,9.536,0,0,0-2.13-.32ZM57.28,45.6,37.77,53.33a10.729,10.729,0,0,1-5.91.58L14.97,50.86V35.96l4.52-1.02a7.517,7.517,0,0,1,3.62.08l9.47,2.57a1.992,1.992,0,0,1,1.27,1.02,1.725,1.725,0,0,1,.03,1.44,2.036,2.036,0,0,1-2.02,1.17l-8.22-1.7a1,1,0,0,0-.41,1.96l8.28,1.71a.355.355,0,0,0,.1.02c.14.01.27.02.4.02a4.068,4.068,0,0,0,3.2-1.55,56.551,56.551,0,0,0,6.62.61,55.905,55.905,0,0,0,7.3-.34c1.08-.11,2.16-.29,3.2-.46,1.14-.19,2.32-.39,3.48-.49a1.969,1.969,0,0,1,2.15,1.12l.43,1.18A1.814,1.814,0,0,1,57.28,45.6Z"/>
                                  <path d="M49.5,31.5h-6a2.006,2.006,0,0,0-2,2v2a2.006,2.006,0,0,0,2,2h6a2.006,2.006,0,0,0,2-2v-2A2.006,2.006,0,0,0,49.5,31.5Zm0,4h-6v-2h6Z"/>
                                </g>
                              </svg>
                              <span>Local Delivery</span>
              `);
          }
          if(deliveryData.classification == 'Shipping'){
            const tab3Li = firstLi.closest('.cs-tabs.cs-crawler-tabs').find('li[rel="cs-tab3"]');
            tab3Li.addClass('invisible');
          }

          let deliveryCalendarData = theme.customDeliveryConditions.determineDeliveryCalendarDetails(deliveryData.classification);
          let disabledCalendarDates = defineDisabledCalendarDates(deliveryCalendarData);
          //Check if pre-selected delivery date is still available. Otherwise, adjust to the earliest possible date
          let preSelectedDate = updateReturnSelectedDate(deliveryCalendarData, deliveryData);
  
          $(this).find('#required-error').hide();
          $('#sbzBox').find('#csShippingpicker').val(deliveryData.date);
          $('#sbzBox').find('#csOrderTypeValue').val(deliveryData.classification);
          $('#sbzBox').find('#csShippingDateValue').val(deliveryData.date);
          $('#sbzBox').find('#csShippingDayValue').val(deliveryData.day);
          $('#sbzBox').find('#csShippingProvince').val(deliveryData.state);
          $('#sbzBox').find('#csShippingZip').val(deliveryData.zip);
          $('#sbzBox').find('#csShippingpicker').hide();
  
          if(deliveryData.classification == "Local Delivery"){
            $('#sbzBox').find('#csShippingpicker').val('');
            $('#sbzBox').find('#csShippingDateValue').val('');
            $('#sbzBox').find('#csShippingDayValue').val('');
  
            $('#sbzBox').find('#csDatepicker').val(deliveryData.date);
            $('#sbzBox').find('#csDeliveryDateValue').val(deliveryData.date);
            $('#sbzBox').find('#csDeliveryDayValue').val(deliveryData.day);
  
            $('#sbzBox').find('#csLocationId').val(locationId);
          }
  
          cartForm.attr('action', `/cart?step=contact_information&checkout[shipping_address][address1]=&checkout[shipping_address][address2]=&checkout[shipping_address][city]=&checkout[shipping_address][zip]=${deliveryData.zip}&checkout[shipping_address][country]=US&checkout[shipping_address][province]=${deliveryData.state}`);
          
          let zipInput = $('#sbzBox [name="attributes[Shipping Delivery Zip]"]');
          if (zipInput.length) {
            zipInput.val(deliveryData.zip);
          } else {
            $('<input>').attr({
              type: 'hidden',
              name: 'attributes[Shipping Delivery Zip]',
              id: 'shippingZipValue',
              value: deliveryData.zip
            }).insertAfter('#sbzBox #csShippingTimeValue');
          }
  
          let stateInput = $('#sbzBox [name="attributes[Shipping Delivery State]"]');
          if (stateInput.length) {
            stateInput.val(deliveryData.state);
          } else {
            $('<input>').attr({
              type: 'hidden',
              name: 'attributes[Shipping Delivery State]',
              id: 'shippingStateValue',
              value: deliveryData.state
            }).insertAfter('#sbzBox #csShippingTimeValue');
          }
  
          let newDateInput = $('#sbzBox #custom_csShippingpicker');
          if (!newDateInput.length) {
            newDateInput = $('<input>').attr({
              type: 'text',
              id: 'custom_csShippingpicker',
              placeholder: 'Select Delivery Date',
              style: 'background-image:url("https://sbz.cirkleinc.com/assets/images/calender.svg")',
              class: 'input-block datePicker csIgnoreCngEvent',
              value: deliveryData.date,
            }).insertAfter('#sbzBox #csShippingpicker');
          }else{
            stateInput.val(deliveryData.date);
          }
  
          let minDate = dateTimeInPstTimezone;
          minDate = minDate.set({ day:(minDate.day + deliveryCalendarData.addToDate)});
          minDate = minDate.toFormat('M/d/yyyy');
               
          const pickr_config = {
            dateFormat: "m/d/Y",
            minDate: minDate,
            defaultDate: deliveryData.date,
            disable: disabledCalendarDates.allDisabledDates,
            onChange: function (selectedDates, dateStr, instance) {
              const selectedDate = selectedDates[0];
              const dayOfWeek = selectedDate.toLocaleDateString('en-US', { weekday: 'long' });
              $('#sbzBox').find('#csShippingpicker').val(dateStr.trim());
              $('#sbzBox').find('#csShippingDateValue').val(dateStr.trim());
              $('#sbzBox').find('#csShippingDayValue').val(dayOfWeek);
  
              if(deliveryData.classification == "Local Delivery"){
                $('#sbzBox').find('#csShippingpicker').val('');
                $('#sbzBox').find('#csShippingDateValue').val('');
                $('#sbzBox').find('#csShippingDayValue').val('');
      
                $('#sbzBox').find('#csDatepicker').val(dateStr.trim());
                $('#sbzBox').find('#csDeliveryDateValue').val(dateStr.trim());
                $('#sbzBox').find('#csDeliveryDayValue').val(dayOfWeek);
              }
            }
          }

          let flatpickrNewInstance = configureFlatpickr(newDateInput, pickr_config);
        }
      }
  
      const lastLi = $(e.target).closest('.cs-tabs.cs-crawler-tabs li[rel="cs-tab3"]');
      if (lastLi.length > 0) {
          $('#sbzBox').find('#csShippingProvince').val('');
          $('#sbzBox').find('#csShippingZip').val('');
          $('#sbzBox').find('#shippingStateValue').val('');
          $('#sbzBox').find('#shippingZipValue').val('');
          $('#sbzBox').find('#custom_csShippingpicker').val('');
      }
    })
  
  });

  function configureFlatpickr(element, config) {
    return element.flatpickr({
      ...config
    });
  }

  function updateReturnSelectedDate(deliveryCalendarData, storedDeliveryData, automaticAdjustment = true){    
    let preSelectedDate = luxon.DateTime.fromFormat(storedDeliveryData.date, 'MM/dd/yyyy', { zone: pstTimezone });
    let minDate = dateTimeInPstTimezone;
    minDate = minDate.set({ day:(minDate.day + deliveryCalendarData.addToDate)});

    let disabledCalendarDates = defineDisabledCalendarDates(deliveryCalendarData);

    if(preSelectedDate < minDate){
      preSelectedDate = minDate;
    }
    
    while(isDateDisabled(preSelectedDate, deliveryCalendarData.disabledDays, disabledCalendarDates.allDisabledDates, deliveryCalendarData.addToDate)){
      preSelectedDate = preSelectedDate.set({ day:(preSelectedDate.day + 1)});
    }

    if(automaticAdjustment){
      storedDeliveryData.date = preSelectedDate.toFormat('MM/dd/yyyy');     
      storedDeliveryData.day = preSelectedDate.toFormat('cccc');
      localStorage.setItem('delivery', JSON.stringify(storedDeliveryData));
    }

    return preSelectedDate;
  }

  function defineDisabledCalendarDates(deliveryCalendarData){
    let disabledDatesRange = '';
    if(deliveryCalendarData.disabledDatesRange != undefined){
      disabledDatesRange = {};
      disabledDatesRange.from = new Date (deliveryCalendarData.disabledDatesRange.from + 'T00:00:00.000-08:00');
      disabledDatesRange.to = new Date (deliveryCalendarData.disabledDatesRange.to + 'T00:00:00.000-08:00');
    }
       
    let allDisabledDates = [
      function(date) {
        return (deliveryCalendarData.disabledDays).includes(date.getDay());
      },
      disabledDatesRange,
      ...disabledDeliveryDates.map((date) => new Date(`${date}T00:00:00.000-08:00`)),
    ];

    const disabledCalendarDates = {
      disabledDatesRange: disabledDatesRange,
      allDisabledDates: allDisabledDates
    }

    return disabledCalendarDates;
  }

  function isDateDisabled(dateInPst, disabledDays, disabledDates, addToDate) {
    return disabledDates.some(disabledDate => {      
      if(typeof disabledDate === 'function'){
        let dayOfWeek = dateInPst.weekday;
        if(dayOfWeek === 7){dayOfWeek = 0;}
        else{dayOfWeek = dayOfWeek;}
        return disabledDays.includes(dayOfWeek);
      }
      else if (disabledDate.from && disabledDate.to) {
        return dateInPst >= disabledDate.from && dateInPst <= disabledDate.to;
      }else{
        if(disabledDate != ''){
          return dateInPst.toISODate() === disabledDate.toDateString();
        }
      }
    });
  }

  return {
    updateReturnSelectedDate: updateReturnSelectedDate
  }
  
})();


$(theme.init);